/* global FB * /
/*global openFB */
/*global CryptoJS */
import SplashScreenOverlay from './UI/splashScreenOverlay';
import React, { Component } from 'react';
import {
    HashRouter,
    Redirect
} from "react-router-dom";
import propTypes from 'prop-types';
import { router } from './router/index'
import {
    roomAssistanceStatusChange, getClientConfig, getWetherInfo, setGuestLogin,
    updateCurrentLayout, updateDurationLang, updateDefaultLanguage,
    setFaceData, fetchFaceBasedJson, DefaultFaceData, facebookProfile,
    setNavItem, setCallKeyclick, setLauncherWidget, setRegPage, allColors, firstOnHome,
    setTVtype, HealthService, setPreloadScreen, popupOpenClose, currentWidget, setGuesLogin,
    setDeviceConfigFailed, setServiceUnavailable, setMobileTVPage, setMobileOverlayState,
    setLanguageList, setInstalledAppVersion, setAppPackageName, setInstalledAppBuildNo, setDoorKeyNotificaionPage, setQRScannerPage, setDoorKeyValidationPopUp,
    setCameraPermission, setAppName, setCurrentWindow, wrongLayoutTypeRenderer, setFailScreen, getDigitalKeySupportedAuthMethods, setInstalledAndroidSDKVersion, setPreCheckInWidgetState, setUnreadMessageCountWeb, setZingleOnStatus, setShowBookmarkPopup, setQueuedCheckInSuccess, 
    showAdhocAction, updateAdhocData, checkBookingStatus, setShowAutoLoginPopup, setHotelSelectionAfterLoginState,
    setRenderHomePage,
    setShowTVLiftWidget,
    setShowCustomPopup
} from '../action/action'
import {
    guestLanguage, guestDetails, getHotelLanguages, setCheckinGuestList,
    getServerTime, fetchSissonToken, guestJourneyNotification, getGuestStepsDropdownOptions, getLatestAppVersion, sendAnalytics, setDoorKeyGuide, setWarningPopup
} from '../action/homeAction'
import { setAccompanyGuestData } from './action/autoCheckin';
import { setNavItemExplore, setNavItemMystay, setNavItemList, setGuestDeviceLang, setNewHeader, setChatWidgetInnitialized, setCurrentTabNavItemList, setDeviceConfifApiCall } from './action/action'
import { fetchActivities } from '../action/activityAction'
import { mapComponentToNavItem, mapScrollingWidgetComponentToNavItem } from '../components/shared/mapNavItem'
import { connect } from 'react-redux'
import { bookVirginListAtTabClickKeys, locationSelectorWidget, myTripsKeys, musicWidgetTypes, navItemsConstant, notificationKeys, theKnowKeys } from '../config/layout2constant'
import { CMSPath, bluetoothCheckMsg, ENABLESTICKYHEADER, ENABLELANGSELECTION, serviceFailureMsg, USEFRESHCHAT, FRESHCHATTOKEN, FRESHCHATHOST, DEMO, ZINGLE_DEMO, CRASHLYTICSCOLLECTION, DEBUG, EXIT, QRSCANENABLE, VERIFY_THROUGH_CMS, INROOMTAB, globalSalt, globalIV, WEB_VERSION_ENABLED, WITH_MASTER_CONNECTOR, internetCheckMsg, DONT_FORCE_TO_ENABLE_PERMISSION_WHILE_DOORKEY_BUT_JUST_WARN } from '../config/constant'
import { languageSelector } from '../components/shared/languageSelector'
import { getCurrentSchedule, getLayout, hashCode } from '../components/shared/layoutSelector'
import { fetchSessionToken } from '../JS/fetchSessionToken'
import { setColor } from '../JS/setColors'
import { checkStatus } from '../components/shared/facebookOauth'
import { wipeGuestData } from '../JS/wipeGuestData'
import { VDAStatusApi, getInncomRoomControlData, setAcSelected, setSelectedAC, setCurrentZoneStep, setCurrentWindowTintPage, setSelectedTintLevel, getTvLiftStatus, getRoomControlZonesWiseData } from '../action/roomControlAction'
import StickyHeader from './components/header/stickyHeader';
// import './css/normalize.css'
// import './css/default.css'
// import './theme/theme.css'
//  import './fa/css/all.min.css'
// import './fa/css/brands.min.css'
// import './css/swiper.min.css'
import './css/loginPop.css'
import './app2.css'

//import '../JS/swiper.js'
import { setGoHome, setOpenCheckin, setOpenViewBill, setFAQUrl, setTnCUrl, setPrivacyPolicyUrl, addLangWidget, setCustomCSSPath, setGuestPreferedLang, setLoader, setLoaderClosed, setNotification, setLoginRequired ,setRedirectInfo, setSelectedList, setCurrentHomePage, setExternalSignIn, setPermissionWhileDoorKeyInfo } from './action/homeAction'
import AdminLoginPage from './components/adminLoginPage/adminLoginPage'
import ConfirmaionPopUp from '../layout2.0/UI/confirmationPopup'
import ConfirmationPopup from '../layout2.0/UI/warningConfirmationPopup'
import Header from './components/header/header'
import FooterNavigation from './components/footerNaviagtion/footerNavigation'
import GuestDeviceReg from '../components/guest-device-registration/guestDeviceReg'
// import DoorNotification from '../layout2.0/components/doorKey/doorNotification'
import DoorNotification from '../UI/doorKey/DoorNotification'
import RoomDoorKey from '../UI/doorKey/roomDoor';
import PreLoaderScreen from '../layout2.0/UI/preLoaderScreen'
import OrderSuccessPopUp from './UI/orderSuccessPopUp'
import { homeColor } from './JS/colorConfig'
// import LoginPopUp from '../layout2.0/components/doorKey/loginPopUp'
import LoginPopUp from '../UI/doorKey/loginPopUp'
import CheckOutConfirm from '../layout2.0/components/viewBill2/confirmationPopUp'
import SucFailViewBillPop from '../layout2.0/components/viewBill2/successFailPopUp'
import PopUp from '../layout2.0/UI/popUp'
import LaodingMass from '../UI/loadingMass/loadingMass'
import NIHPopup from '../UI/new-popup/NIHPopup'
import QRScannerPage from '../UI/doorKey/QRScannerPage'
import GuestLoginPage from './components/guestLoginFlow/guestLoginPage'
import { fetchLayoutType } from '../JS/fetchLayoutType'
import DoorErrorPopup from '../UI/doorKey/errorPop'
import { getFCMToken } from './components/home/notifications/pushNotification';
import {calculateTimeDifference, copy_to_tempstorage_if_exists, generateToken, getDefaultAnalyticsLabel, toBool} from './JS/utility';
import { changePage, setItemTypeList, resetHcommerce, setSelectedSubItemListStoreLevel2, setSelectedSubItemStoreLevel2, setHCommerceSavedOrders } from '../action/hcommerce'
import { setShowPlaceOrder } from './action/hCommerce2';
import SelectLanguagePopup from './UI/selectLanguagePopup';
import {useTranslation} from "react-i18next";
import i18next from "i18next";
import ErrorBoundary from './components/home/ErrorBoundry'
import {loadAndCacheCSS, loadCSS} from '../JS/cssImport'
import $, { css } from 'jquery'
import Freshchat from 'react-freshchat';
import { scrollUpListenerToShowHideElement, scrollUpListener } from './components/roomControl2/scrollEffect'
import HappyUnhappy from './components/home/happyUnhappy'
import NoConnection from './components/home/noConnection'
import Loader from './UI/loader'
import SuccessFailCheckoutPopUp from './components/viewBill2/successFailPopUp'
import {setSuccessFailPop} from  './action/viewBillAction2'
import {getStoreInfo} from '../action/hcommerce'
import {setHcommerceWidget, setCustomLocation, setSelectedGuestName} from "./action/hCommerce2"
import {setSelectedIdType, setIdCardImage, setIdCardImageBack, setSelfieVideo} from "./action/autoCheckin"
import { getSurvey, setGuestRequestList } from '../action/guestRequest'
import SuccessFailScreen from './UI/SuccessFailScreen';
import moment from 'moment';
import NotifiicationBox from './UI/notifiicationBox';
import DoorKeyStepsGuide from '../UI/doorKey/doorKeyStepsGuide';
import {saveGuestRequest} from "../action/guestRequest"
import DmqEventHandler from './components/home/dmqEventHandler.jsx';
import { dmqEventListener, registerDmqEvent } from '../JS/dmqEventsListener';
import LoginRequiredOverlay from './UI/loginRequiredOverlay';
import { initializeChat } from "./components/chatWidget/initializeChat"
import RedirectOnLoad from '../UI/widgetDisplayTypes/redirectOnLoad';
import { CustomPreLoader1 } from './components/customAfterLoaderScreen/customPreLoaderScreen1';
import LaunchGuide from './UI/launchGuide';
import { withTranslation } from 'react-i18next'
import SendSMS from './components/smsWidget/sendSMS';
import AppInfoPage from './components/guestLoginFlow/appInfoPage';
import { AesUtil } from '../JS/AesUtil';
import NotAvailWebPopup from './UI/notAvailOnWebPopup';
import QueuedBookingSuccess from './components/autoCheckin/queuedBookingSuccess';
import checkPreCheckinWidgetState from './components/home/checkPreCheckInWidgetState';
import BookmarkPopup from './components/bookmarkPopup/bookmarkPopup';
import { fetchAdhoc } from './action/adhoc';
import Adhoc from './components/adhoc/adhoc';
import CustomAfterLoaderScreen1 from './components/customAfterLoaderScreen/customAfterLoaderScreen1';
import CustomAfterLoaderScreen2 from './components/customAfterLoaderScreen/customAfterLoaderScreen2';
import { InnSpireChatShowConversation, getInnSpireChatUnreadCount } from './components/chatWidget/innpirechatbot';
import CustomPreLoader2 from './components/customAfterLoaderScreen/customPreLoaderScreen2';
import { getGuestItinerary } from '../action/guestItinerary.js';
import GuestItineraryDetails from './components/guestItinerary/guestItineraryDetails.jsx';
import AutoLoginPopup from './components/guestLoginFlow/autoLoginPopup.jsx';
import HotelChangeConfirmPopup from './components/hotelSelector/HotelChangeConfirmPopup.jsx';
import { handleLocationSelect, handlePreCheckInStorage } from './components/hotelSelector/hotelSelector.js';
import { getHotelList, getHotelListUpdatingProps } from '../action/hotelSelector.js';
import { setOpenExternalLinkInSameTab } from './action/homeAction';
import CustomPopup from './components/CustomPopup.jsx';
import CurrentPlayingSong  from '../components/music/current-song/current_song.jsx';
import { userAutoLoginUsingTheKnow } from './components/theKnow/helper.js';
import { checkIsBluetoothEnabledForDoorKey } from '../UI/doorKey/helper.js';
// import { trace } from 'firebase/performance';
// import { perf } from '../index.js';

// window.runAfterPermissionsCheck = (key) => {
//    console.log("runAfterPermissionCheck being called", key);
// };

window.checkKeyPageOpen = (key) => {
    try {
        if (window.AppCompRef)
            window.AppCompRef.checkAssaAbloy(key);
        else
            console.log("AppCompRef error")
    } catch (e) {
        console.log("error while tring to call js function from Native:", e);
    }
}

class App2 extends Component {
    constructor(props) {
        super(props);
        this.timer = null;
        this.timeoutTimer = null;
        this.loaderTimer = null;
        this.showedLaunchGuide = false;
        this.aesUtil = new AesUtil(128, 1000);
        this.state = {
            currentLayout: {},
            currentLang: "",
            tokenAvailable: false,
            onlyOnce: true,
            openCheckin:false,
            openViewBill:false,
            showLangPopup:true,
            isLangSet:false,
            infosaved: false,
            languageLst: [],
            showSplash: false,
            defaultThemeCssFile: false,
            room: null,
            showStickyHeader: false,
            isDeviceConfigResponse: false,
            doorKeyiOSInitiated: false,
            isHotelPrefLanguageResponse: false,
            isServerTimeResponse: false,
            serviceUnavailableMessage: '',
            chatInitialized: false,
            test: false,
            webBackHandlerTriggered: false,
            webBackHandlerTriggeredPath: null,
            renderLaunchGuideAsPerDeepLink: true,
            launchGuideCheckedState: false,
            launchGuideState: false,
            gotMenuColor: false,
            AppLaunchTime: new Date,
            firstLaunch: true,
            getServerTimeInterval: false,
            appInBackground: false,
            numOfRegisterCalls: 0,
            openBookmarkPopup: false,
            closeCustomAfterLoaderScreen: true,
            redirectOnLoadVar: false,
            launchedToResetPermissionWhileDoorKeyInfo : false,
            analyticsSentForFailedAppLaunch:false,
            mountStartTimeCount: new Date().getTime()
        }
        // window.AppCompRef = this
    }

  
    // app_load_trace =  trace(perf, "App_load2");

    customHandlingIsPermissionEnabledForDoorKey = (isEnabled, permissionType) =>{

        const permissionDetails={
            BLUETOOTH:{
                errorMessage: bluetoothCheckMsg,
                warnCountVariableNameInStore: "bluetoothWarnCount"
            }
        }

        if(isEnabled){
            this.sendGAEvent(`${permissionType} ACCESS - SUCCESS`, "", () => {}, {"pageName": "UNLOCK DOOR PAGE"});
            return true
        } else{
            if(DONT_FORCE_TO_ENABLE_PERMISSION_WHILE_DOORKEY_BUT_JUST_WARN && this.props.permissionWhileDoorKeyInfo[permissionDetails[permissionType]["warnCountVariableNameInStore"]] >= 1){
                this.sendGAEvent(`${permissionType} ACCESS - FAILED - BUT MAKING IT EXCEPTIONALLY PASS IN APP`, permissionDetails[permissionType]["errorMessage"] , () => {}, {"pageName": "UNLOCK DOOR PAGE"});
                return true;
            } else {
                this.sendGAEvent(`${permissionType} ACCESS - FAILED`, permissionDetails[permissionType]["errorMessage"], () => {}, {"pageName": "UNLOCK DOOR PAGE"});
                this.props.setPermissionWhileDoorKeyInfo({ [permissionDetails[permissionType]["warnCountVariableNameInStore"]] : this.props.permissionWhileDoorKeyInfo[permissionDetails[permissionType]["warnCountVariableNameInStore"]] + 1})
                this.onDoorKeyPermissionError(permissionType)
                return false
            }
        }
    }

    sendGAEvent = (eventName, action,  callback, extraLabelInfo) => {
        try{
                let room = localStorage.getItem("room");
            
                let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
                this.props.sendAnalytics(
                    this.props.guestDetail, 
                    eventName, 
                    action, 
                    {...label, ...extraLabelInfo}, 
                    0, 
                    (room && room != "null") ? room : false
                );
        } catch{

        }
    }


    onDoorKeyPermissionError = (feature)=> {

        if(feature == "BLUETOOTH"){
            this.props.popupOpenClose(true, bluetoothCheckMsg);
        } else {
            this.sendGAEvent("DOOR KEY VALIDATION - FAILED - ISSUE UNKNOWN", "Something went wrong.", () => {}, {"pageName": "UNLOCK DOOR PAGE"})
             
        }
    }

    checkAssaAbloy= ()=>{
        try{
            console.log("checkKeyPageOpen called");
            if (this.props.showDoorKeyPage) {
                let door_key_type = localStorage.getItem("door_key_type");
    
                if(window.device){
    
        
                    const isBluetoothEnabled = checkIsBluetoothEnabledForDoorKey(door_key_type, window.device.platform);
                    const isBluetoothEnabledCustomCheck = this.customHandlingIsPermissionEnabledForDoorKey(isBluetoothEnabled, "BLUETOOTH");
    
    
                    if( isBluetoothEnabledCustomCheck ){
                    
                        if(window.device.platform == "Android"){
                                switch(door_key_type){
                                    case "AA":
                                        window.assaabloy.activateFile();
                                        break;
                                    case "DK":
                                        window.dormakaba.activateFile();
                                        break;
                                    case "SALTO":
                                        window.salto.activateFile();
                                        break;
                                }
                        } else{
                                switch(door_key_type){
                                    case "AA":
                                        if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) {
                                            window.cordova.plugins.AssaAbloy.activateFile(
                                                "hello",
                                                () => { console.log("openLock success") },
                                                () => { console.log("openLock failed") }
                                            );
                                        }
                                        break;
                                    case "DK":
                                        if (window.cordova && window.cordova.plugins && window.cordova.plugins.Dormakaba) {
                                            window.cordova.plugins.Dormakaba.activateFile(
                                                "hello",
                                                () => { console.log("openLock success") },
                                                () => { console.log("openLock failed") }
                                            );
                                        }
                                        break;
                                    case "SALTO":
                                        if (window.cordova && window.cordova.plugins && window.cordova.plugins.Salto) {
                                            window.cordova.plugins.Salto.activateFile(
                                                "hello",
                                                () => { console.log("openLock success") },
                                                () => { console.log("openLock failed") }
                                            );
                                        }
                                        break;
                                }
                        }
                    }
    
                }
            }
        } catch{

        }
    }
    
    static getDerivedStateFromProps(props, state) {
        if (state.onlyOnce) {
            // console.log("call to getDerivedStateFromProps");
            props.setPreloadScreen(true);
        }
        let currentHash
        let storedHash = sessionStorage.getItem("hashForLayout");
        let currentLayout, codeToHash, schedule, curLangStr;
        let lang = localStorage.getItem('GuestPreferedLang');
        curLangStr = languageSelector(props);
        if (props.faceData) {
            if (props.schedules) {
                schedule = {
                    schedules: props.schedules[lang],
                    language: lang
                }
                console.log('getLayout lang', lang)
                // console.log("schedules schedule", schedule);
            } else {
                schedule = {
                    schedules: props.defaultLayouts[lang],
                    language: lang
                }
                //console.log("default schedule", props.schedules, schedule);
            }
        } else {
            schedule = getCurrentSchedule(props);
            console.log("schedule", schedule);
        }
        /*
        if (props.durationLang && schedule.language && props.durationLang !== schedule.language) {
          console.log("props.guestLanguages , schedule.language", props.durationLang, schedule.language)
          alert(props.layoutText.alertText);
        }
        */
        currentLayout = getLayout(props, schedule);
        console.log('setting current duration')
        console.log('currentLayout.durationId',currentLayout, props.durationId)
        codeToHash = JSON.stringify(currentLayout);
        currentHash = codeToHash ? hashCode(codeToHash) : 0
        sessionStorage.setItem("hashForLayout", currentHash);
        //console.log("current Layout", currentLayout)
        if (currentLayout && ((props.durationId !== currentLayout.durationId && currentHash !== storedHash) || (props.deviceConfifApiCall))) {
            props.setDeviceConfifApiCall(false);
            if (!localStorage.getItem("LayoutMaster") || localStorage.getItem("LayoutMaster") === "null") localStorage.setItem("LayoutMaster", currentLayout.layoutTypeName);
            fetchLayoutType(currentLayout);
            // console.log("Hash", currentHash);
            props.updateCurrentLayout(currentLayout, schedule.language, curLangStr);
            if (currentLayout.brandingInfo) {
                let weatherColor, menuColor;
                if (currentLayout.brandingInfo && currentLayout.brandingInfo.app
                    && currentLayout.brandingInfo.app.menuWidget) {
                    menuColor = currentLayout.brandingInfo.app.menuWidget;
                }
                //setColor(menuColor);
                homeColor(menuColor)
                props.allColors(menuColor);
            }
            // Milind: Commented as the scrollableWidget structure has changed.
            // mapComponentToNavItem(props, currentLayout.scrollableWidgets.widgets, navItemsConstant);
            //    console.log('Scrollable Widget: ', currentLayout.scrollableWidgets);
            console.log('current layout', currentLayout)
            // if(currentLayout.layoutTypeName == 'webapp-type2'){            
                currentLayout.scrollableWidgets.map(tab => {
                    console.log('tabtab.uniqueKey', tab.uniqueKey)
                    if(tab.uniqueKey === "notifications" || tab.uniqueKey === "Notifications" || tab.uniqueKey === "notification" || tab.uniqueKey === "Notification" || tab.uniqueKey == "more"){
                        console.log('tab.widgets',tab.widgets)
                        tab.widgets.map(widget => {
                            widget.subWidgetMap.map( widget => {
                                if(widget.widgetType == 'FAQ'){
                                    props.setFAQUrl(widget.targetUrl);
                                } else if (widget.widgetType == 'Privacy Policy'){
                                    props.setPrivacyPolicyUrl(widget.targetUrl);
                                } else if (widget.widgetType == 'Terms and Condition'){
                                    props.setTnCUrl(widget.targetUrl);
                                } else if(widget.widgetType == 'Language'){
                                    props.addLangWidget(true);
                                }

                                if(!widget.widgetType.includes('Language') && props.langWidget == null ){
                                    props.addLangWidget(false);
                                }
                            });
                            
                        });
                    } else {                        
                        mapScrollingWidgetComponentToNavItem(props, currentLayout.scrollableWidgets, navItemsConstant);
                    }
                });
            // } else {
            //     wrongLayoutTypeRenderer(currentLayout.layoutTypeName, null, props)
            //     return null;
            // }

            // Milind: Commented as the scrollableWidget structure has changed.
            //  props.fetchActivities(currentLayout.scrollableWidgets.widgets);

        } else if (props.durationLang && schedule.language && props.durationLang !== schedule.language) {
            props.updateDurationLang(schedule.language);
        }
        // if (props.firstTimeOnHome < 2) {
        //   console.log("new state", props.firstTimeOnHome);
        //   props.firstOnHome(props.firstTimeOnHome + 1);
        //   setColor(props.menuColor);
        // }
        // if (props.menuColor && props.menuColor.assetBackgroundColor) {
        //     //console.log("getDerivedStateFromProps color change");
        //     setColor(props.menuColor);
        //     homeColor(props.menuColor)
        // }
        return {
            currentLayout,
            currentLang: props.guestLanguages,
        }
    }

    checkBookmark = (serverDate) => {
        
        if(WEB_VERSION_ENABLED){
            if(localStorage.getItem("bookmarkShownDate")){
                const serverDateObj = new Date(serverDate);
                const bookmarkDateObj = new Date(localStorage.getItem("bookmarkShownDate"));

                if(serverDateObj > bookmarkDateObj){
                    this.setState({openBookmarkPopup: true})
                    localStorage.setItem("bookmarkShownDate", serverDate)
                }
            } else {
                this.setState({openBookmarkPopup: true})
                localStorage.setItem("bookmarkShownDate", serverDate)
            }
        }
    }
    
    requiredRoute = (eventData) => {
        console.log('Did launch app from the link: ' + JSON.stringify(eventData));
        
        let room = localStorage.getItem("room");
        const current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
        const hotel_code = eventData.params.hotel ? eventData.params.hotel : null

        const redirectInfo = {
            path: eventData.params.appPath ? eventData.params.appPath : undefined ,
            storeSku: eventData.params.storeSku ? eventData.params.storeSku : undefined,
            widgetType: eventData.params.widgetType ? eventData.params.widgetType : undefined,
            appPath: eventData.params.appPath ? eventData.params.appPath : undefined ,
            checkInAuthToken: eventData.params.checkInAuthToken ? eventData.params.checkInAuthToken : undefined,
            guestDetailsToken: eventData.params.guestDetailsToken ? eventData.params.guestDetailsToken : undefined,
            loginAuthToken: eventData.params.loginAuthToken ? eventData.params.loginAuthToken : undefined,
            bottomTabID:  eventData.params.bottomTabID ? eventData.params.bottomTabID : undefined,
        }

        // below condition will save checkIn guest info in localStorage, So if below condition is true then it would skip lastname check.
        if(eventData.params.checkInAuthToken){
            let checkInGuestPreInfo = this.aesUtil.decrypt( globalSalt, globalIV, "1234567891234567", eventData.params.checkInAuthToken )
            if(checkInGuestPreInfo) localStorage.setItem("checkInGuestPreInfo", checkInGuestPreInfo)
        }

        if(eventData.params.guestDetailsToken){
            let checkInGuestPreInfo = atob(eventData.params.guestDetailsToken);
            if(checkInGuestPreInfo) localStorage.setItem("checkInGuestPreInfo", checkInGuestPreInfo);
        }

        if(eventData.params.bottomTabID){
            if (this.props.footerTabList.length > 0) {
                let requiredTab = null;
                
                this.props.footerTabList.forEach(item => {
                    if (item.uniqueKey.toLowerCase() === eventData.params.bottomTabID.toLowerCase() || 
                        item.tabName.replace(/ /g, '').toLowerCase() === eventData.params.bottomTabID.toLowerCase()) {
                        requiredTab = item;
                    }
                });
                if(requiredTab){
                    const selectedTab = requiredTab;
                    
                    const currentWidgetsList = this.props.widgetList.find(item =>
                        item.uniqueKey === selectedTab.uniqueKey || 
                        item.uniqueKey === selectedTab.tabName.replace(/ /g, '').toLowerCase()
                    );
                    if (currentWidgetsList) {
                        this.props.setGoHome(true);
                        this.props.setCurrentHomePage(selectedTab);
                        this.props.setCurrentTabNavItemList(currentWidgetsList.widgets);
                    }
                }
            } else {
                sessionStorage.setItem("bottomTabID", eventData.params.bottomTabID);
            }
        }

        this.props.setRedirectInfo(redirectInfo)
        if(redirectInfo.path) this.setState({renderLaunchGuideAsPerDeepLink: false});

        setTimeout(() => {

            if(hotel_code && hotel_code != current_hotel_code){
                this.handleHotelSelection(hotel_code, redirectInfo);
                return;
            }

            if(eventData.params.loginAuthToken && (!room || room == "null")){
                let loginGuestInfo = this.aesUtil.decrypt( globalSalt, globalIV, "1234567891234567", eventData.params.loginAuthToken )
                this.props.setShowAutoLoginPopup(true, loginGuestInfo);
            } else {
                if(redirectInfo.path) this.setState({redirectOnLoadVar: true})
            }
        }, 100);
    }

    redirectRouteWeb = () => {

        let room = localStorage.getItem("room");
        const current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();

        const appPath = new URLSearchParams(window.location.search).get('appPath');
        const storeSku = new URLSearchParams(window.location.search).get('storeSku') || null;
        const widgetType = new URLSearchParams(window.location.search).get('widgetType') || null;
        const checkInAuthToken = new URLSearchParams(window.location.search).get('checkInAuthToken') || null;
        const guestDetailsToken = new URLSearchParams(window.location.search).get('guestDetailsToken') || null;
        const loginAuthToken = new URLSearchParams(window.location.search).get('loginAuthToken') || null;
        const hotel_code = new URLSearchParams(window.location.search).get('hotel') || null;
        const bottomTabID = new URLSearchParams(window.location.search).get('bottomTabID') || null;


        const theKnowUserInfo = new URLSearchParams(window.location.search).get('theKnowUserInfo');

            const redirectInfo = {
                path: appPath ,
                storeSku: storeSku,
                widgetType: widgetType,
                appPath: appPath,
                checkInAuthToken: checkInAuthToken,
                guestDetailsToken: guestDetailsToken,
                loginAuthToken: loginAuthToken,
                bottomTabID: bottomTabID
            }

            if(!sessionStorage.getItem("redirectWeb")){


                if(redirectInfo.path) this.setState({renderLaunchGuideAsPerDeepLink: false});


                // the know web conditions
                if(theKnowUserInfo){
                    localStorage.setItem("theKnowUserInfo", theKnowUserInfo)    

                    let parsedTheKnowUserInfo = JSON.parse(theKnowUserInfo) || {};

                    parsedTheKnowUserInfo.memberId && this.props.setExternalSignIn("memberId", parsedTheKnowUserInfo.memberId);
                    parsedTheKnowUserInfo.accessToken && this.props.setExternalSignIn("accessToken", parsedTheKnowUserInfo.accessToken);
                    parsedTheKnowUserInfo.refreshToken && this.props.setExternalSignIn("refreshToken", parsedTheKnowUserInfo.refreshToken);
                }

                // below condition will save checkIn guest info in localStorage, So if below condition is true then it would skip lastname check.
                if(checkInAuthToken){
                    let checkInGuestPreInfo = this.aesUtil.decrypt( globalSalt, globalIV, "1234567891234567", checkInAuthToken )
                    if(checkInGuestPreInfo) localStorage.setItem("checkInGuestPreInfo", checkInGuestPreInfo)
                }

                if(guestDetailsToken){
                    let checkInGuestPreInfo = atob(guestDetailsToken);
                    if(checkInGuestPreInfo) localStorage.setItem("checkInGuestPreInfo", checkInGuestPreInfo);
                }

                if(bottomTabID){
                    if (this.props.footerTabList.length > 0) {
                        let requiredTab = null;
                        
                        this.props.footerTabList.forEach(item => {
                            if (item.uniqueKey.toLowerCase() === bottomTabID.toLowerCase() || 
                                item.tabName.replace(/ /g, '').toLowerCase() === bottomTabID.toLowerCase()) {
                                requiredTab = item;
                            }
                        });
                        if(requiredTab){
                            const selectedTab = requiredTab;
                            
                            const currentWidgetsList = this.props.widgetList.find(item =>
                                item.uniqueKey === selectedTab.uniqueKey || 
                                item.uniqueKey === selectedTab.tabName.replace(/ /g, '').toLowerCase()
                            );
                            if (currentWidgetsList) {
                                this.props.setGoHome(true);
                                this.props.setCurrentHomePage(selectedTab);
                                this.props.setCurrentTabNavItemList(currentWidgetsList.widgets);
                            }
                        }
                    } else {
                        sessionStorage.setItem("bottomTabID", bottomTabID);
                    }
                    
                }

                sessionStorage.setItem("redirectWeb", true)
                this.props.setRedirectInfo(redirectInfo)
                
                setTimeout(() => {

                    if(hotel_code && hotel_code != current_hotel_code){
                        this.handleHotelSelection(hotel_code, redirectInfo);
                        return;
                    }

                    if(loginAuthToken && (!room || room == "null")){
                        let loginGuestInfo = this.aesUtil.decrypt( globalSalt, globalIV, "1234567891234567", loginAuthToken )
                        this.props.setShowAutoLoginPopup(true, loginGuestInfo);
                    } else {
                        if(redirectInfo.path) this.setState({redirectOnLoadVar: true})
                    }
                }, 100);
            }
    }

    handleHotelSelection = (hotel_code, redirectInfo) => {
        getHotelList()
        .then((res) => {
            if (res.status === 200) {
                const hotelList = res.data.payload && res.data.payload.data || [];
                for (const hotelDataAsPerLocation of hotelList) {
                    if (hotelDataAsPerLocation.hotelList && hotelDataAsPerLocation.hotelList.length > 0) {
                        for (const hotelData of hotelDataAsPerLocation.hotelList) {
                            if (hotelData.hotelPropertyKey == hotel_code) {
                                sessionStorage.setItem("redirectInfo", JSON.stringify(redirectInfo));
                                handleLocationSelect(this.props, hotelData, false);
                                break;
                            }
                        }
                    }
                }
            }
        })
        .catch((err) => {})
    }
    

    componentDidUpdate(prevPro, prevState) {
        // console.log('this.props.layoutType',this.props.layoutType)
        // // this.props.durations.map(obj => {
        //     if(this.props.layoutType == 'webapp-type1'){
        //         console.log('webapp-type1 loaded')
        //         this.props.setServiceUnavailable(true)
        //     }
        // })

        const { t } = this.props


        if(prevPro.guestIsLoggedIn != this.props.guestIsLoggedIn){
            if(WITH_MASTER_CONNECTOR && sessionStorage.getItem("ConnectorIP")){
                const room = localStorage.getItem("room");
                if(room && room != "null"){
                    localStorage.setItem("ConnectorIP", sessionStorage.getItem("ConnectorIP"))
                    localStorage.setItem("clientId", sessionStorage.getItem("clientId"))
                }
            }
        }

        if(!this.state.gotMenuColor && this.props.menuColor.backgroundColor){
            $("body").attr('style', `background: ${this.props.menuColor.backgroundColor} !Important`);

            if(window.StatusBar) window.StatusBar.backgroundColorByHexString(this.props.menuColor.statusBarBackgroundColor? this.props.menuColor.statusBarBackgroundColor : this.props.menuColor.backgroundColor)
            this.setState({gotMenuColor: true})
            console.log('this.props.menuC**', this.props.menuColor.backgroundColor, this.props.menuColor)    
        }

        let guestSelectedLang = localStorage.getItem('GuestPreferedLang')
        let defaultThemeCssFileLoaded = localStorage.getItem('defaultThemeCssFileLoaded')
        let layoutIds = this.props.schedules[guestSelectedLang? guestSelectedLang: 'en'] ? this.props.schedules[guestSelectedLang? guestSelectedLang: 'en'].map(obj => obj.layoutId) : ''
        let layoutId = localStorage.getItem('currentDuration')
        let currentCSSVersion =  localStorage.getItem('currentCSSVersion')
        let currentLayoutId =  localStorage.getItem('currentLayoutId')
        let room = localStorage.getItem("room");

        let master_hotel_code = (process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
        let current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();

        // there is a known random case where 'room' key get remained in LocalStorage and is not null, because of that renderHomePage remains False. Hence this is added to ensure that while on corp, there is never Room number, so remove it explicitly
        if( WITH_MASTER_CONNECTOR && master_hotel_code == current_hotel_code && room && room != "null" ){
            room = null;
            localStorage.setItem("room",null);
        }

        if(!layoutId){
            layoutId = this.props.durationId
        } 


        if( (prevPro.guestIsLoggedIn != this.props.guestIsLoggedIn) || this.props.guestIsLoggedIn){
            const checkInguestInfo = this.props.loginGuestDetails ? this.props.loginGuestDetails : JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"));
            if(checkInguestInfo && checkInguestInfo[0]){
                if(!this.props.renderHomePage) this.props.setRenderHomePage(true);
        }}
    
        if(!room || room == "null"){
            if(!this.props.renderHomePage) this.props.setRenderHomePage(true);
        }

        // if(this.props.renderHomePage && this.state.isDeviceConfigResponse && this.state.isServerTimeResponse && this.state.isHotelPrefLanguageResponse) { console.log("heelooo"); try{this.app_load_trace.stop();}catch(e){}}
        
        // if(this.props.renderHomePage && this.state.isDeviceConfigResponse && this.state.isServerTimeResponse && this.state.isHotelPrefLanguageResponse) { if(window && window.FirebasePlugin) window.FirebasePlugin.stopTrace("App_Load");}

        console.log('layoutId********',layoutId)
        if(this.props.latestCssData && !this.state.infosaved){
            this.props.latestCssData.map( cssObj => {
            
                // loads Custom CSS
                if(cssObj.layoutId == layoutId){
                    console.log('Css from custom css file rendered')
                    this.setState({infosaved: true })
                    console.log('this.props.latestCssData',this.props.latestCssData)
                    if (process.env.REACT_APP_CACHE_DYNAMIC_CSS == "true" && window.cordova && (!WITH_MASTER_CONNECTOR || master_hotel_code !== current_hotel_code)) {
                        loadAndCacheCSS(`${CMSPath}${cssObj.customCSSFile}`, cssObj.cssVersion)
                    }else{
                        loadCSS(`${CMSPath}${cssObj.customCSSFile}`, cssObj.cssVersion)
                    }                    
                    if(window.StatusBar && this.props.menuColor.backgroundColor) window.StatusBar.backgroundColorByHexString(this.props.menuColor.statusBarBackgroundColor? this.props.menuColor.statusBarBackgroundColor : this.props.menuColor.backgroundColor)
                    if(!currentCSSVersion || currentCSSVersion == 'null' || currentCSSVersion < cssObj.cssVersion || currentLayoutId != cssObj.layoutId){
                        console.log('setted CSS file')
                        localStorage.setItem('currentLayoutId', cssObj.layoutId)
                        localStorage.setItem('currentCSSVersion', cssObj.cssVersion)
                    }

                } else if (!defaultThemeCssFileLoaded){
                    localStorage.setItem('defaultThemeCssFileLoaded', true)
                    console.log('Css from theme.css rendered')
                    loadCSS("layout_2/theme/theme.css")
                }
            });
        } else if (!defaultThemeCssFileLoaded){
            localStorage.setItem('defaultThemeCssFileLoaded', true)
            loadCSS("layout_2/theme/theme.css")
        }

        console.log('this.props.currentWidget', this.props.currentWidgetOb)
            
        let sessionToken = localStorage.getItem('GuestJourneySessionToken');
        if (prevPro.guestCheckedOut !== this.props.guestCheckedOut) {
            if (sessionToken && room && room !== "null") {
                if (!this.props.guestCheckedOut) {
                    console.log("guest is out @@@");
                    localStorage.setItem('GuestCheckedOut', true)
                    wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"})
                }
            }
        }

        if(this.props.freshChatData && this.props.freshChatData.logout && !this.state.chatInitialized){
            console.log('this.props.freshChatData',this.props.freshChatData, this.state.chatInitialized)

            if(room && room != "null"){
                if(localStorage.getItem("Set_Current_Logged_In_Guest_Details")){
                    initializeChat(this.props , (status) => {
                        if(status){
                            this.setState({chatInitialized: true})
                        }
                    })
                }
            } else {
                initializeChat(this.props , (status) => {
                    if(status){
                        this.setState({chatInitialized: true})
                    }
                })
            }
        }

        if(localStorage.getItem('GuestCheckedOut') == 'true'){
            if(prevPro.showSucFailPop !== this.props.showSucFailPop) this.props.setSuccessFailPop(true, true)
        }

        const shouldShowLaunchGuide = this.state.isDeviceConfigResponse
        && !this.props.GuestDevReg
        && (this.props.langWidget ? this.state.isLangSet : true)
        && (this.props.screenInfoAfterLoader && this.props.screenInfoAfterLoader.showAfterScreen ? sessionStorage.getItem("shownWelcomButton") : true )
        && this.state.renderLaunchGuideAsPerDeepLink
        && !this.state.launchGuideCheckedState
        && this.showLaunchGuide()
        && !this.showedLaunchGuide

        if (shouldShowLaunchGuide) {
            $("body").addClass("overlay-cast");
            $("body").addClass("overlay-click");
            this.showedLaunchGuide = true;
        }
        if((this.props.screenInfoAfterLoader && this.props.screenInfoAfterLoader.showAfterScreen)){
            if(this.state.closeCustomAfterLoaderScreen){
                this.setState({closeCustomAfterLoaderScreen: false})
            } 
        }
        if(Object.keys(this.props.screenInfoAfterLoader).length !== 0 && !this.props.screenInfoAfterLoader.showOnlyAtFirstLaunch && localStorage.getItem("shownWelcomButton")){
            localStorage.removeItem("shownWelcomButton");
            sessionStorage.removeItem("shownWelcomButton")
        }

        if((localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) && !this.state.getServerTimeInterval){
            this.setState({getServerTimeInterval: true});

            const serverTimeInterval = window.setInterval(() => {

            if(!localStorage.getItem("X_CHECKIN_PQ_DATA") && !sessionStorage.getItem("X_CHECKIN_PQ_DATA")){
                clearInterval(serverTimeInterval);
            } else {
            this.props.getServerTime((status,payload) => {
                if(status){
                    this.setState({isServerTimeResponse: true})
    
                    this.props.serverTimeDate && checkPreCheckinWidgetState(this.props);
                    
                    // removing checkin data from localStorage
                    let checkInDataPayload = (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) && JSON.parse(this.aesUtil.decrypt(globalSalt, globalIV, "1234567891234567",localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")))
                    if(payload && payload.date && checkInDataPayload.checkinDate){
    
                        const serverDateObj = new Date(payload.date.slice(0, 10));
                        const checkinDateObj = new Date(checkInDataPayload.checkinDate);
    
                        if(serverDateObj > checkinDateObj){
                            localStorage.removeItem("X_CHECKIN_PQ_DATA");
                            sessionStorage.removeItem("X_CHECKIN_PQ_DATA")
                        }
                    }

                    if(room && room != "null"){
                        localStorage.removeItem("X_CHECKIN_PQ_DATA");
                        sessionStorage.removeItem("X_CHECKIN_PQ_DATA")
                    }    

                    handlePreCheckInStorage();
                } else {
                    if(!this.props.serverTimeDate){ 
                        this.setState({serviceUnavailableMessage: 'Unable to retrieve server time. Please try again or contact the front desk for assistance.' })
                        this.props.setServiceUnavailable(true)
                    }
                }
            })};
            }, 120000)
        }

        if( this.props.showBookmarkPopup && this.props.serverTimeDate){
            this.checkBookmark(this.props.serverTimeDate && this.props.serverTimeDate.split("T")[0]);
            this.props.setShowBookmarkPopup(false);
        }

        if(prevState.isDeviceConfigResponse != this.state.isDeviceConfigResponse && !this.state.doorKeyiOSInitiated){
            this.setState({doorKeyiOSInitiated: true});

            setTimeout(() => {
                let door_key_type = process.env.REACT_APP_DOOR_KEY_TYPE;

                if(this.props.digitalKeyInterface == "AssaAbloy"){
                    door_key_type = "AA"
                } else if(this.props.digitalKeyInterface == "Dormakaba"){
                    door_key_type = "DK";
                } else if(this.props.digitalKeyInterface == "Salto"){
                    door_key_type = "SALTO"
                }


                localStorage.setItem("door_key_type", door_key_type);

                if(window.device && window.device.platform == "iOS"){
                    if(door_key_type == "AA"){
                        if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) {
                            window.cordova.plugins.AssaAbloy.initializePlugin(
                                "Initialize",
                                () => { console.log("initializePlugin success") },
                                () => { console.log("initializePlugin failed") }
                            )
                        }
                    } 
                    
                    if(door_key_type == "DK"){
                        if (window.cordova && window.cordova.plugins && window.cordova.plugins.Dormakaba) {
                            window.cordova.plugins.Dormakaba.initializePlugin(
                                "Initialize",
                                () => { console.log("initializePlugin success") },
                                () => { console.log("initializePlugin failed") }
                            )
                        }
                    }

                    if(door_key_type == "SALTO"){
                        if (window.cordova && window.cordova.plugins && window.cordova.plugins.Salto) {
                            window.cordova.plugins.Salto.initializePlugin(
                                "Initialize",
                                () => { console.log("initializePlugin success") },
                                () => { console.log("initializePlugin failed") }
                            )
                        }
                    }

                }

                


            }, 1000);
        }

        if(room && room != "null" && localStorage.getItem("Set_Current_Logged_In_Guest_Details") && this.state.isDeviceConfigResponse && localStorage.getItem("queuedLoggedIn") && !this.props.queuedCheckInSuccess){
            this.props.setQueuedCheckInSuccess(true);
        }

        if(room && room != "null" && localStorage.getItem("Set_Current_Logged_In_Guest_Details") && this.state.isDeviceConfigResponse && localStorage.getItem("autoLoggedIn") && !this.props.showAutoLoginPopup){
            this.props.setShowAutoLoginPopup(true);
        }

        if(!this.state.analyticsSentForFailedAppLaunch && (this.props.deviceConfigFailed || this.props.serviceUnavailable)){

            if(!navigator.onLine){
                if(window && window.FirebasePlugin) window.FirebasePlugin.incrementCounter("App_Load_failed","offline");

            }

            if(window && window.FirebasePlugin) window.FirebasePlugin.stopTrace("App_Load_failed");
            if(window.FirebasePlugin  ) window.FirebasePlugin.setCrashlyticsCustomKey('App_Load_failed', "" );

            
            console.log("sending analytics that App has failed to launch...")
            
            let analyticsToBeSent = {
                isDeviceConfigResponse: this.state.isDeviceConfigResponse && this.props.deviceConfigFailed  ,
                isServerTimeResponse: this.state.isServerTimeResponse ,
                isHotelPrefLanguageResponse: this.state.isHotelPrefLanguageResponse,
                loadingTimeInterval: new Date().getTime() - this.state.mountStartTimeCount
            }
            
            


            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                "APP_LOADING_FAILED", 
                "Failed to load", 
                {...label,   ...analyticsToBeSent }, 
                0, 
                (room && room != "null") ? room : false
            );
            this.setState({analyticsSentForFailedAppLaunch : true });

        }

        // if(){
        //     this.props.setPreloadScreen(false)
        // }

        if( DONT_FORCE_TO_ENABLE_PERMISSION_WHILE_DOORKEY_BUT_JUST_WARN && this.props.permissionWhileDoorKeyInfo && !this.state.launchedToResetPermissionWhileDoorKeyInfo && (this.props.permissionWhileDoorKeyInfo.bluetoothWarnCount > 0 || this.props.permissionWhileDoorKeyInfo.internetWarnCount > 0 ) ){

            this.setState({launchedToResetPermissionWhileDoorKeyInfo:true});

            window.setTimeout(()=>{
                this.setState({launchedToResetPermissionWhileDoorKeyInfo:false});
                this.props.setPermissionWhileDoorKeyInfo({
                    bluetoothWarnCount:0,
                    internetWarnCount:0
                })
            }, 5*60*1000)
        }
        
    }

    callForLayout = (userData, token, repeatedCall) => {

        if(!navigator.onLine){
            if(window && window.FirebasePlugin) window.FirebasePlugin.incrementCounter("App_Load_failed","offline");

            // this.props.setDeviceConfigFailed(true);
            // this.props.setPreloadScreen(false);
            // return;
        }

        if(this.state.firstLaunch){
            this.setState({firstLaunch: false})
            // Send Analytics
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                "APP_LAUNCH", 
                "LAUNCHED", 
                {...label }, 
                0, 
                (room && room != "null") ? room : false
            );
            //
        }

        let room = localStorage.getItem("room");
        let roomID = localStorage.getItem("roomID");
        let date = new Date();
        let birthyear, age;
        let sentJson;
        if (userData && userData.gender && userData.birthday) {
            birthyear = parseInt(userData.birthday.slice(6, 10));
            age = (date.getFullYear()) - birthyear;
            //console.log("user Data", userData, age, userData.gender);
            sentJson = {
                "age": `${age ? age : 42}`,
                "classificationType": "Leisure",
                "gender": `${userData.gender ? userData.gender : "male"}`,
            }
            this.props.fetchFaceBasedJson(JSON.stringify(sentJson), this.props, (status, isOffline) => this.deviceConfigCallBack(status, repeatedCall, isOffline), window.timeoutTimer, window.loaderTimer);
        } else if ((!room || room === "null") && !roomID) {
            // sentJson = {
            //     "age": `42`,
            //     "classificationType": "Leisure",
            //     "gender": `male`,
            // }
            sentJson = {
                "age": `36`,
                "classificationType": localStorage.getItem("marketSegment") || process.env.REACT_APP_MARKET_SEGMENT,
                "gender": `male`,
            }
            this.props.fetchFaceBasedJson(JSON.stringify(sentJson), this.props, (status, isOffline) => this.deviceConfigCallBack(status, repeatedCall, isOffline), window.timeoutTimer, window.loaderTimer);
        } else {
            // console.log("in else fpr Call for layout.");
            this.props.getClientConfig(token, this.props, (status, isOffline) => this.getLayoutCallBack(status, repeatedCall, isOffline), window.timeoutTimer, window.loaderTimer);
        }
    }

    getLayoutCallBack = (status, repeatedCall, isOffline) => {

        if (status && isOffline) {
            this.props.setShowCustomPopup(true, {
                htmlTagId: "app-offline",
                title: "You're Offline",
                heading: "It looks like your internet connection is lost. Please reconnect and tap below to refresh.",
                primaryButtonText: "Try Again",
                closeOnClick:()=>{this.props.setShowCustomPopup(false,{})},
                primaryOnClick: () => { window.location.reload() },
            })
        }

        this.setState({isDeviceConfigResponse: true})
        
        // console.log("got colback", status);
        // this.props.setPreloadScreen(false);
        // window.clearTimeout(this.timeoutTimer);
        // this.props.getStoreInfo(this.props.storeSku, this.props.guestDetail)
        this.getDeviceLanguage();
        if (!status) {
            // this.props.popupOpenClose(true, "Network Issue.");
            // this.props.setServiceUnavailable(true);
            this.setState({serviceUnavailableMessage: 'Unable to retrieve device config data. Please try again or contact the front desk for assistance.' })
            this.props.setServiceUnavailable(true);
            // this.props.setDeviceConfigFailed(true);
            if(window && window.FirebasePlugin) window.FirebasePlugin.incrementCounter("App_Load_failed","deviceConfig_api_issue");

        }

        let token = localStorage.getItem("GuestJourneySessionToken")
        let installedAppVersion = localStorage.getItem('installedVersion')
        let installedAppPackageName = localStorage.getItem('packagename')
        this.props.getLatestAppVersion(token,installedAppPackageName, window.device ? window.device.platform: '', installedAppVersion, this.checkForForceUpdate);

        if(repeatedCall){
            let schedule = getCurrentSchedule(this.props);
            let currentLayout = getLayout(this.props, schedule);
            console.log()
            let storedLayout = localStorage.getItem('currentDuration')

            console.log('Checking schedule update => current layout: ',currentLayout.durationId, ' previous layout: ', storedLayout)

            if(currentLayout.durationId !== storedLayout) {
                window.location.reload()
            }
        }
        // this.props.getSurvey(() => {});
    }



    deviceConfigCallBack = (status, repeatedCall, isOffline) => {

        if (status && isOffline) {
            this.props.setShowCustomPopup(true, {
                htmlTagId: "app-offline",
                title: "You're Offline",
                heading: "It looks like your internet connection is lost. Please reconnect and tap below to refresh.",
                primaryButtonText: "Try Again",
                closeOnClick:()=>{this.props.setShowCustomPopup(false,{})},
                primaryOnClick: () => { window.location.reload() },
            })
        }

        // console.log("got colback", status);

        // console.log('this.props.layoutType',this.props.layoutType)
        // // this.props.durations.map(obj => {
        //     if(this.props.layoutType == 'webapp-type1'){
        //         console.log('webapp-type1 loaded')
        //         this.props.setServiceUnavailable(true)
        //     }
        // })

        this.setState({isDeviceConfigResponse: true})
        
        // this.props.setPreloadScreen(false);
        console.log('device config failed', status)
        // window.clearTimeout(this.timeoutTimer);
        this.getDeviceLanguage();
        if (!status) {
            // this.props.popupOpenClose(true, "Network Issue.");
            this.setState({serviceUnavailableMessage: 'Unable to retrieve device config data. Please try again or contact the front desk for assistance.' })
            this.props.setServiceUnavailable(true);
            // this.props.setDeviceConfigFailed(true);
        }

        let token = localStorage.getItem("GuestJourneySessionToken")
        let installedAppVersion = localStorage.getItem('installedVersion')
        let installedAppPackageName = localStorage.getItem('packagename')
        this.props.getLatestAppVersion(token,installedAppPackageName, window.device ? window.device.platform: '', installedAppVersion, this.checkForForceUpdate);

        console.log("repeatedCall",repeatedCall)
        if(repeatedCall){
            let schedule = getCurrentSchedule(this.props);
            let currentLayout = getLayout(this.props, schedule);
            console.log()
            let storedLayout = localStorage.getItem('currentDuration')

            console.log('Checking schedule update => current layout: ',currentLayout.durationId, ' previous layout: ', storedLayout)

            if(currentLayout.durationId !== storedLayout) {
                window.location.reload()
            }
        }
        // this.props.getSurvey(() => {});
    }
    sessionTokenFlow = () => {
        if(!navigator.onLine){
            if(window && window.FirebasePlugin) window.FirebasePlugin.incrementCounter("App_Load_failed","offline");

            // this.props.setDeviceConfigFailed(true);
            // this.props.setPreloadScreen(false);
            // return;
        }
        let encodedData = fetchSessionToken();
        this.props.fetchSissonToken(encodedData, this.makeLayoutAPICalls, this.props.deviceName);
        //console.log("encodedData", encodedData);
    }

    callWebAppPing = () => {

        let room = localStorage.getItem('room')
        let roomId = localStorage.getItem("roomID");
        let token = localStorage.getItem("GuestJourneySessionToken");

        if(INROOMTAB){
            this.props.HealthService(token);
        } else {
            if((room && room !== "null") || localStorage.getItem("X_CHECKIN_PQ_DATA")) 
                this.props.HealthService(token);
        }
    }

    makeLayoutAPICalls = (token, status) => {

        if(!this.props.serviceUnavailable){

        if(this.state.numOfRegisterCalls >= 5){
            this.setState({serviceUnavailableMessage: 'Unable to retrieve session token. Please try again or contact the front desk for assistance.' })
            this.props.setServiceUnavailable(true);
            return;
        }

        setTimeout(() => {
            if(!token || token == "null" || token == "undefined"){
                let encodedData = fetchSessionToken();
                this.setState({numOfRegisterCalls: this.state.numOfRegisterCalls + 1})
                this.props.fetchSissonToken(encodedData, this.makeLayoutAPICalls, this.props.deviceName);
                return
            }

        console.log('navigator.onLine',navigator.onLine)
        let guestToken = localStorage.getItem('guestToken')
        let room = localStorage.getItem('room')
        let roomId = localStorage.getItem("roomID")

        if(!token && status === 503){
            this.props.setServiceUnavailable(true);
            return;
        } 
        console.log("apiCalles");

        if(sessionStorage.getItem("redirectInfo")){
            console.log("in localStorage RedirectInfo")
            console.log(sessionStorage.getItem("redirectInfo"))

            const redirectEventData = {
                params: {
                    ...JSON.parse(sessionStorage.getItem("redirectInfo"))
                }
            }

            sessionStorage.removeItem("redirectInfo")
            this.requiredRoute(redirectEventData)
        }
        
        if(window.universalLinks) window.universalLinks.subscribe('requiredRoute', this.requiredRoute);

        this.redirectRouteWeb();

        let userData = localStorage.getItem("FB_user_info");
        userData = JSON.parse(userData);
        this.props.DefaultFaceData();
        this.props.guestLanguage(token);
        this.props.getHotelLanguages(token, status => {
            if(status){
                this.setState({isHotelPrefLanguageResponse: true})
            } else {
                if(window && window.FirebasePlugin) window.FirebasePlugin.incrementCounter("App_Load_failed","hotel_lang_api_issue");
                this.setState({serviceUnavailableMessage: 'Unable to retrieve hotel languages. Please try again or contact the front desk for assistance.' })
                this.props.setServiceUnavailable(true)
            }
        });
        this.callForLayout(userData, token);
        window.setInterval(() => {
            if(INROOMTAB){
                this.props.HealthService(token);
            } else {
                if(!this.state.appInBackground && room && room !== "null"){
                    this.props.HealthService(token);
                } else if(!this.state.appInBackground && localStorage.getItem("X_CHECKIN_PQ_DATA")){
                    this.props.HealthService(token);
                }
            }
        }, 180000);
        this.callWebAppPing();


        window.setInterval(() => {
            this.props.getGuestItinerary();
        }, 300000)
        this.props.getGuestItinerary();

        this.props.getHotelListUpdatingProps();

        if (window.FirebasePlugin) {
            let updateFCMTokenTry = 0;

            const updateFCMToken = window.setInterval(() => {
                if ((localStorage.getItem("GuestJourneySessionToken") && localStorage.getItem("FCM_token")) || updateFCMTokenTry >= 10) {
                    clearInterval(updateFCMToken);
                } else {
                    updateFCMTokenTry++;
                    getFCMToken();
                }
            }, 3000);
            
            getFCMToken();
        }


        if(localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) {
            this.props.checkBookingStatus();
        }

        if(this.props.externalSignIn.memberId){  
            userAutoLoginUsingTheKnow(this.props);
        }

        this.props.getServerTime((status,payload) => {
            if(status){
                this.setState({isServerTimeResponse: true})

                // removing checkin data from localStorage
                let checkInDataPayload = (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))&& JSON.parse(this.aesUtil.decrypt(globalSalt, globalIV, "1234567891234567",localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")))
                if(payload && payload.date && checkInDataPayload && checkInDataPayload.checkinDate){

                    const serverDateObj = new Date(payload.date.slice(0, 10));
                    const checkinDateObj = new Date(checkInDataPayload.checkinDate);

                    if(serverDateObj > checkinDateObj){
                        localStorage.removeItem("X_CHECKIN_PQ_DATA");
                        sessionStorage.removeItem("X_CHECKIN_PQ_DATA")
                    }
                }

                if(room && room != "null"){
                    localStorage.removeItem("X_CHECKIN_PQ_DATA");
                    sessionStorage.removeItem("X_CHECKIN_PQ_DATA")
                }

                handlePreCheckInStorage();

                window.setInterval(() => {                    
                    fetchAdhoc(this.props);
                }, 180000)
                
            } else {
                if(window && window.FirebasePlugin) window.FirebasePlugin.incrementCounter("App_Load_failed","server_time_api_issue");                
                this.setState({serviceUnavailableMessage: 'Unable to retrieve server time. Please try again or contact the front desk for assistance.' })
                this.props.setServiceUnavailable(true)
            }
        });
        let checkinGuestList = localStorage.getItem("Check_In_Guest_List")
        let guestDetails = localStorage.getItem("Guest_Details")
        let currentLoginGuest = localStorage.getItem("Set_Current_Logged_In_Guest_Details")
        let guestListSetTimestamp = localStorage.getItem("GuestListSetTimestamp")

        let diff = moment().diff(guestListSetTimestamp, "minute")

        if(!checkinGuestList || !guestDetails || !currentLoginGuest || checkinGuestList == "null" || guestDetails == "null" || currentLoginGuest == "null" || diff > 120)
            this.props.guestDetails(token, wipeGuestData, guestToken, this.props.saveGuestRequest);
        else{
            this.props.setCheckinGuestList(JSON.parse(checkinGuestList), JSON.parse(guestDetails), JSON.parse(currentLoginGuest))
        }

        setInterval(() => {
            this.props.guestDetails(token, wipeGuestData, guestToken);
        }, 10 * 60 * 1000)

        setTimeout(() => {
            this.props.guestJourneyNotification(token);
        }, 4000);

        this.props.getGuestStepsDropdownOptions(token);

        window.setInterval(() => {
            this.props.guestJourneyNotification(token);
        },180000);
        /*setInterval(() => {
          this.callForLayout(userData);
        }, 900000);*/
             this.props.getWetherInfo(token);
        // this.props.VDAStatusApi(
        //     token, this.props.guestDetail,
        //     this.VDACallBack, this
        // )
        console.log('this.props.guestDetail',guestDetails)
        
        if((room && room !== "null") || roomId){

            this.props.getTvLiftStatus(roomId, (status) => {
                this.props.setShowTVLiftWidget(status);
            });
            
            setTimeout(() => {this.props.getRoomControlZonesWiseData(this.props.guestDetail)}, 2000)
            setTimeout(() => {this.props.getInncomRoomControlData(token, this.props.guestDetail)}, 2000)
        }

        }, 1000);
    }}

    VDACallBack = (status, thisRef) => {

    }

    facebookOauthInit = () => {
        if (window.cordova) {
            openFB.init({ appId: '449978942427999' });//daigo->2292736537663885//Inn->449978942427999
        }
        else {
            window.fbAsyncInit = function () {
                FB.init({
                    appId: '449978942427999',
                    autoLogAppEvents: true,
                    xfbml: true,
                    version: 'v3.3'//daigo-v3.2//Inn-v3.3
                });

                FB.Canvas.setSize({ height: 420 });
            };
        }
    }

    removeCookies = () => {
        // console.log("remove cookies");
        let cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            let eqPos = cookie.indexOf("=");
            let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }

    setBackButtonListner = () => {

        const handleBackButton = () => {
            if(this.props.showLoader){
                console.log('restrict back button for loader screens')
            } if(this.props.showGuestLogin){
                this.props.setGuestLogin(false)
            } else if(this.props.showPlaceOrder){
                this.props.setShowPlaceOrder(false);
                this.props.setCustomLocation(null)
                this.props.setSelectedGuestName(null)
            } else if(this.props.showWarningPopup.show){
                this.props.setWarningPopup({show: false, msg: ""});
            }else if(this.props.currentWidgetOb && this.props.currentWidgetOb.widgetType == "Guest Requests"){
                if(this.props.selectedList && this.props.selectedList.length > 0){
                    this.props.setWarningPopup({show: true, msg: "You have requests pending. Are you sure you want to exit?"})
                }  else {
                    this.props.setGoHome(true);
                }
            } else if(this.props.currentPage === 'itemInfo'){
                if (this.props.SelectedNavComponent === 'StoreLevel1') {
                    this.props.changePage("StoreLevel1");
                }
                else {
                    this.props.changePage("StoreLevel2");
                }
            } else if(this.props.subItemListStoreLevel2.length > 0){
                this.props.setSelectedSubItemListStoreLevel2([])
                this.props.setSelectedSubItemStoreLevel2(null)
            } else if(this.props.currentPage === 'StoreLevel1' || this.props.currentPage === "StoreItemTypeList"){
                if(this.props.hCommerceSavedOrders && this.props.hCommerceSavedOrders.length > 0){
                    this.props.setWarningPopup({show: true, msg: "There are items in the cart. Are you sure you want to exit?"})
                }  else {
                    this.props.setGoHome(true);
                }
            } else if(this.props.currentPage === 'StoreLevel2'){
                this.props.changePage("StoreLevel1");
            } else if((window.location.hash).startsWith("#/notifications/readMsg")){
                window.history.back()
            } else if((window.location.hash).startsWith("#/mobileTV")){
                this.props.setMobileTVPage(false)
                this.props.setGoHome(true);
            } else if(window.location.hash.startsWith('#/change_profile_photo')){
                if(notificationKeys.some(el => el === this.props.selectedHomePage.uniqueKey)){
                    window.location.hash = ('/notifications')
                    console.log('back listener for notification')
                } else {
                    this.props.setGoHome(true)
                }
            } else if((window.location.hash).startsWith("#/notifications/writeMsg")){
                window.history.back()
            } else if((window.location.hash).startsWith("#/RoomControl2")){
                if(this.props.acSelected && this.props.hvac.length > 1){
                    this.props.setAcSelected(false)
                    this.props.setSelectedAC([])
                } else if(this.props.currentWindow){
                    this.props.setCurrentWindow(null)
                } else {
                    this.props.setAcSelected(false)
                    this.props.setSelectedAC([])
                    window.history.back()
                }
            } else if(this.props.QRScanPage 
                || window.location.hash.startsWith('#/doorKey/roomDoorKey')
                || this.props.mobileOverlayState
                || this.props.showDoorKeyPage){

                    this.props.currentWidget({});

                    if (window.QRScanner) {
                        window.QRScanner.destroy( status =>console.log("Qr scanner destroyed",status));
                    }

                    this.props.setGoHome(true);
                    this.props.setDoorKeyNotificaionPage(false);
                    this.props.setDoorKeyValidationPopUp(false);
                    this.props.setMobileOverlayState(false);
            } else if((window.location.hash).startsWith("#/viewBill2") && this.props.showLoader){
                console.log('restrict the backbutton here')
            } else if(this.props.currentZoneStep == 3){
                this.props.setCurrentZoneStep(2)
            } else if(this.props.currentZoneStep == 2){
                this.props.setCurrentZoneStep(1)
                this.props.setSelectedTintLevel(1)
            } else if(this.props.currentZoneStep == 1){
                this.props.setCurrentWindowTintPage("")
            } else if(this.props.currentTintWindow == "SleepIn" ){
                this.props.setCurrentWindowTintPage("")
            } else {
                this.props.setGoHome(true);
            }
        }

        if(window.device){
            document.addEventListener('backbutton', () => {
                
                // remove response if back button click
                localStorage.removeItem("GDPR-Response")
                this.props.setRedirectInfo({})
                this.setState({redirectOnLoadVar: false})
    
                console.log('backlistner called')
    
                if(this.props.deviceConfigFailed || this.props.serviceUnavailable){
                    navigator.app.exitApp();
                }else{
                    if(this.props.GuestDevReg){
                        this.props.setGoHome(true);
                        this.props.setRegPage(false)
                    } else if(!this.props.currentWidgetOb.widgetType){
                        navigator.app.exitApp();
                    } else {
                        handleBackButton();
                    }
                }
    
                {/*
                if(this.props.currentPage === 'StoreLevel1'){
                        this.props.setGoHome(true);
                    } else if(this.props.currentPage === 'StoreLevel2'){
                        this.props.changePage("StoreLevel1");
                    } else if(this.props.currentPage === 'itemInfo'){
                        if (this.props.SelectedNavComponent === 'StoreLevel1') {
                            this.props.changePage("StoreLevel1");
                        }
                        else {
                            this.props.changePage("StoreLevel2");
                        }
                    } else if(this.props.showPlaceOrder){
                            this.props.setShowPlaceOrder(false)
                    } else{
                        this.props.setGoHome(true);
                    }
                */}
    
                //event.preventDefault();
                //navigator.app.backHistory();
    
                // alert(this.constructor.name)
                // if (this.constructor.name === 'Explore') {
                //     navigator.app.exitApp();
                // }     
                // else {
                //     this.props.setGoHome(true);
                //     navigator.app.backHistory();
                // }            
    
            }) 
            } else {
                window.addEventListener('popstate', () => {
                    if(window.location.hash == "#/"){
                    localStorage.removeItem("GDPR-Response")
                    this.props.setRedirectInfo({})
                    this.setState({redirectOnLoadVar: false})
    
                    console.log('backlistner called')
    
                    if(this.props.GuestDevReg){
                        this.props.setRegPage(false)
                    } else {
    
                        handleBackButton();
                    }}
                })
            }
    
    
            /* document.addEventListener("backbutton", function(e){
                 if(this.mobile.activePage.is('#homepage')){
                     e.preventDefault();
                     navigator.app.exitApp();
                 }
                 else {
                     navigator.app.backHistory();
                 }
              }, false); */
        }

    webBackHandlerRedirectRoute = () => {

        this.setState({webBackHandlerTriggered: false, webBackHandlerTriggeredPath: null});

        return (
            <HashRouter>
                <Redirect exact to={this.state.webBackHandlerTriggeredPath} />
            </HashRouter>
        )
    }

    getDeviceLanguage = () => {

        let guestPreferedLang = localStorage.getItem('GuestPreferedLang')
        let self = this

        if(navigator.globalization && !guestPreferedLang ){
            navigator.globalization.getPreferredLanguage(
                (language) => {    
                    console.log('language: ' + language.value + '\n');
                    let guestDeviceLang = language.value.slice(0,2)
                    // setGuestPreferedLang(guestDeviceLang);
                    // localStorage.setItem('GuestPreferedLang', guestDeviceLang)
                    self.props.languagelistData.map( langObj => {
                        console.log('language list comparision with device lang', langObj.languageCode, guestDeviceLang)
                        if(langObj.languageCode == guestDeviceLang){
                            self.props.setGuestDeviceLang(guestDeviceLang);
                            localStorage.setItem('GuestPreferedLang', guestDeviceLang)
                            localStorage.setItem('GuestPreferedLangName', langObj.language)
                            window.location.reload()
                        }
                    })
                    console.log('GuestDeviceLang',self.props.guestDeviceLang)
                },
                () => {
                    console.log('Error getting language\n');
                }
            );
        }
    }

    getAppInfo = () => {
        let self =  this
        if(window.cordova && self){
            window.cordova.getAppVersion.getVersionCode(function(version){
                // 10000
                console.log("version code", version);
                // this.setState({ installedAppVersionCode : version });
                localStorage.setItem('installedVersion', version)
                self.props.setInstalledAppBuildNo(version)
            });

            window.cordova.getAppVersion.getVersionNumber(function(versionNumber){
                // 1.0.0
                console.log("version number", versionNumber);
                // this.setState({ installedAppVersion : versionNumber });
                self.props.setInstalledAppVersion(versionNumber)
            });

            window.cordova.getAppVersion.getPackageName(function(pkgname){
                // com.companyname.appname
                console.log("Package Name", pkgname);
                // this.setState({ installedAppPackage : pkgname });
                localStorage.setItem('packagename', pkgname)
                self.props.setAppPackageName(pkgname)
            });

            window.cordova.getAppVersion.getAppName(function(appName){
                self.props.setAppName(appName)
            })

            window.device.getInfo((device) => {
                self.props.setInstalledAndroidSDKVersion(device.version)
            })
        } else {
            localStorage.setItem('installedVersion',process.env.REACT_APP_BUILD_NUMBER)
            self.props.setInstalledAppBuildNo(process.env.REACT_APP_BUILD_NUMBER)
            self.props.setInstalledAppVersion(process.env.REACT_APP_VERSION_NUMBER)
        }
    }

    checkForForceUpdate = (callFromPause) => {

        setTimeout(() => {
            // checking adhoc after layout update
            if(this.props.serverTimeDate) fetchAdhoc(this.props);
        }, 1000);

        console.log('this.props.latestAppData.appUrl',this.props.latestAppData.appUrl)
        console.log('this.props.latestAppData.availableVersion',this.props.latestAppData.availableVersion)
        console.log('this.props.latestAppData.forceUpdate',this.props.latestAppData.forceUpdate)
        console.log('installedAppVersion', this.props.installedAppVersion)

        if(callFromPause){
            console.log('Force update', callFromPause)
        }

        let installedAppVersion = localStorage.getItem('installedVersion')
        let latestVersionInLocal =  localStorage.getItem('latestVersion')
        let updatePopupShown = localStorage.getItem('updatePopupShown') && localStorage.getItem('updatePopupShown') == "true"
        let updateDenied
        
        if(latestVersionInLocal && latestVersionInLocal < this.props.latestAppData.availableVersion){
            updateDenied = localStorage.setItem('updateDenied', false)
        }

        if(this.props.latestAppData.forceUpdate){
            updateDenied = localStorage.setItem('updateDenied', false)
        }
        
        updateDenied = localStorage.getItem('updateDenied')
        console.log('Force Upodate condition',( navigator.notification 
            && installedAppVersion < this.props.latestAppData.availableVersion
            && Number.isInteger(this.props.latestAppData.availableVersion)
            && (!updateDenied || updateDenied == 'false' ) && !updatePopupShown))
        
        console.log('updateDenied inside forceUpdate', updateDenied, !updateDenied, updateDenied == 'false', updateDenied == null)
        if ( navigator.notification 
            && installedAppVersion < this.props.latestAppData.availableVersion
            && Number.isInteger(this.props.latestAppData.availableVersion)
            && (!updateDenied || updateDenied == 'false' )){

            let buttons = [ 'Cancel', 'Update' ];
            let title = 'App update'
            let message

            if(this.props.latestAppData.forceUpdate){
                message = "To continue using this app, please update to get the latest improvements"
            } else {
                message = 'Please update to the latest version to get the latest improvements'
            }
            
            localStorage.setItem('updatePopupShown', true)

            let self = this
            navigator.notification.confirm( message, (response) => {

                console.log("response", response)
            if ( response == 1) {
                // user clicks cancel button
                console.log("reponse 1 from force update popup")
                localStorage.setItem('updatePopupShown', false)
                if(self.props.latestAppData.forceUpdate){
                    navigator.app.exitApp();
                } 
                else {
                    localStorage.setItem('updateDenied', true)
                    localStorage.setItem('latestVersion', self.props.latestAppData.availableVersion)
                }
            } else if( response == 2) {
                console.log("reponse 2 from force update popup")
                // functionality to take user to play or app store
                
                // window.open(this.props.latestAppData.appUrl)
                localStorage.setItem('updatePopupShown', false)
                window.cordova.InAppBrowser.open(`${self.props.latestAppData.appUrl}`, `_system`)
                localStorage.setItem('latestVersion', self.props.latestAppData.availableVersion)

                if(!self.props.latestAppData.forceUpdate){
                    localStorage.setItem('updateDenied', true)
                    localStorage.setItem('latestVersion', self.props.latestAppData.availableVersion)
                }

                // debug popup for confirmation if app is redirecting
                if(DEBUG){
                    let message = `${self.props.latestAppData.appUrl}`
                    let title = 'Update is clicked and now app will redirect to App Store'
                    let buttonTitle = "Ok"
                    navigator.notification.alert(message, () => {}, title, buttonTitle)
                }
            } else {
                // this is the case where user doesn’t clicks anything and closes the app
                console.log("no reponse from force update popup")
                localStorage.setItem('updatePopupShown', false)
                if(self.props.latestAppData.forceUpdate){
                    navigator.app.exitApp();
                }
                 else {
                    localStorage.setItem('updateDenied', true)
                }
                // we have to apply some functionality to handle this case also 
            }

            // this.setState({showSplash: true})
                            
            }, title, buttons)
        }
    }   


    initializeFirebase = () => {

        if (window.FirebasePlugin) {
            console.log('Firebase initialize')
            localStorage.setItem('firebaseInitialized', true)
            //Sets CrashLytics Collection to enable or disable true/false
            let permissionGranted

            window.FirebasePlugin.hasPermission(function(hasPermission){
                console.log("Permission is " + (hasPermission ? "granted" : "denied"));
                permissionGranted = hasPermission
            });

            if(!permissionGranted){
                window.FirebasePlugin.grantPermission(function(hasPermission){
                    console.log("Permission was " + (hasPermission ? "granted" : "denied"));
                });
            }

            window.FirebasePlugin.onMessageReceived(function(message) {
                console.log("FireBase Message " + message);
                console.log("Message type: " + message.messageType);


                if(message.type && message.type.toLowerCase() == "assaabloy"){
                    console.log("received assaabloy notification: ", message.status);
                    
                    if(window.assaabloy) { // this case is for android
                        window.assaabloy.updateEndpointStatus(message.status)
                    } else if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) { // this is for iOS
                        window.cordova.plugins.AssaAbloy.updateEndpointStatus({status: message.status});
                    }
                    return;
                }

                if(message.messageType === "notification"){
                    console.log("Notification message received from Firebase");
                    if(message.tap){
                        console.log("Massege Tapped in " + message.tap);
                    }
                }
                console.dir('message in firebase notifications', message);
            }, function(error) {
                console.error('error in firebase notifications', error);
            });

            window.FirebasePlugin.setCrashlyticsCollectionEnabled(CRASHLYTICSCOLLECTION, function(){
                console.log("Crashlytics data collection is enabled");
            }, function(error){
                console.error("Crashlytics data collection couldn't be enabled: "+error);
            });
        
            //Checks if CrashLytics Collection is enable or disable true/false
            window.FirebasePlugin.isCrashlyticsCollectionEnabled(function(enabled){
                console.log("Crashlytics data collection is "+(enabled ? "enabled" : "disabled"));
            }, function(error){
                console.error("Error getting Crashlytics data collection setting: "+error);
            });

            //Check if crashed on previous excecution 
            window.FirebasePlugin.didCrashOnPreviousExecution(function(didCrashOnPreviousExecution){
                console.log(`Did crash on previous execution: ${didCrashOnPreviousExecution}`)
            }, function(error){
                console.error(`Error getting Crashlytics did crash on previous execution: ${error}`)
            });
            
            //sets user_id must be unique
            let room = localStorage.getItem('room')
            window.FirebasePlugin.setCrashlyticsUserId(room);
            
            // window.FirebasePlugin.logMessage("Testing firebase log messege" + [{"key1": "value1"}, { "key1": "value1"}, { "key1": "value1"} ]);
            // window.FirebasePlugin.logError("Test log error without succees/error function" )
        }

    }


    pauseEventListener = () => {

        document.addEventListener("pause", () =>  {
            // this.checkForForceUpdate()
            let token = localStorage.getItem("GuestJourneySessionToken")
            let guestSelectedLang = localStorage.getItem('GuestPreferedLang')
            let installedAppPackageName = localStorage.getItem('packagename')
            let installedAppVersion = localStorage.getItem('installedVersion')
            let currentCSSVersion = localStorage.getItem('currentCSSVersion')
            let currentLayoutId = localStorage.getItem('currentLayoutId')

            this.setState({appInBackground: true})

            console.log('called the pauseEventListener')
            this.props.getLatestAppVersion(token,installedAppPackageName, window.device ? window.device.platform: '', installedAppVersion, this.checkForForceUpdate('callFromPause'), console.log('api call from pause'));
            let layoutIds = this.props.schedules[guestSelectedLang? guestSelectedLang: 'en'] ? this.props.schedules[guestSelectedLang? guestSelectedLang: 'en'].map(obj => obj.layoutId) : ''
            let layoutId = layoutIds[0]

            console.log('this.props.durationId',this.props.durationId)
            if(!layoutId){
                layoutId = this.props.durationId
            } 
            
            if(this.props.latestCssData){
                this.props.latestCssData.map( cssObj => {
                    // loads Custom CSS
                    if(cssObj.cssVersion < currentCSSVersion || currentLayoutId != cssObj.layoutId ){
                        if(!this.props.currentWidgetOb.widgetType){

                            if(cssObj.layoutId == layoutId[0]){
                                this.setState({infosaved: true })
                                console.log('this.props.latestCssData pause event listener',this.props.latestCssData)
                                if (process.env.REACT_APP_CACHE_DYNAMIC_CSS == "true" && window.cordova) {
                                    loadAndCacheCSS(`${CMSPath}${cssObj.customCSSFile}`, cssObj.cssVersion)
                                }else{
                                    loadCSS(`${CMSPath}${cssObj.customCSSFile}`, cssObj.cssVersion)
                                }
                                localStorage.setItem('currentLayoutId', cssObj.layoutId)
                                localStorage.setItem('currentCSSVersion', cssObj.cssVersion)
                                window.location.reload();
                            }
                        }
                    }
                });
            }
            
        });

        document.addEventListener("resume", () => {            
            this.setState({appInBackground: false});

            this.callWebAppPing();

            this.props.getServerTime();

            if (window.cordova && window.cordova.platformId === "ios" && !localStorage.getItem("FCM_token") && window.FirebasePlugin) {
                window.FirebasePlugin.grantPermission(() => {
                    setTimeout(() => {
                        getFCMToken();
                    }, 2000);
                }, (err) => {
                    setTimeout(() => {
                        getFCMToken();
                    }, 2000);
                });
            }

            // updating innspireChat undread count
            try {
                if(window.InnspireCB){
                    getInnSpireChatUnreadCount((unreadCount) => {
                        this.props.setUnreadMessageCountWeb(unreadCount)
                    })
                }   
            } catch (error) {
                console.log("error getting innspire chat unread count: " + error)
            }
        })
    }
    
    
    componentDidMount() {

        let room = localStorage.getItem("room");
        if(window && window.FirebasePlugin ){

            window.FirebasePlugin.setAnalyticsCollectionEnabled(true);
            window.FirebasePlugin.setPerformanceCollectionEnabled(true);
            window.FirebasePlugin.setCrashlyticsCollectionEnabled(true)
        }

        if (window.cordova && window.cordova.plugins && window.cordova.plugins.BluetoothStatus) {
            window.cordova.plugins.BluetoothStatus.initPlugin();
        }

        if(window && window.FirebasePlugin) window.FirebasePlugin.startTrace("App_Load_failed");

        let master_hotel_code = (process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
        let current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();


        // there is a known random case where 'room' key get remained in LocalStorage and is not null, because of that renderHomePage remains False. Hence this is added to ensure that while on corp, there is never Room number, so remove it explicitly
        if( WITH_MASTER_CONNECTOR && master_hotel_code == current_hotel_code){
            room = null;
            localStorage.setItem("room",null);
        }
        this.setState({"room":room})


        if((!room || room == "null") && !(localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))){
            localStorage.removeItem("adHocEventShownIDList")
        }


        if(localStorage.getItem("GuestJourneyHotelCode") && localStorage.getItem("GuestJourneyHotelCode") != current_hotel_code){
            localStorage.removeItem("GuestJourneySessionToken");
        }


        // below logic is to save session token for master connector
        if(WITH_MASTER_CONNECTOR && localStorage.getItem("GuestJourneySessionToken")){
            if(master_hotel_code == current_hotel_code){
                localStorage.setItem("GuestJourneyMasterConnectorSessionToken", localStorage.getItem("GuestJourneySessionToken"))
            }
        }

        // logic to always switch to master connector at app restart after logout/checkout
        if(WITH_MASTER_CONNECTOR && localStorage.getItem("ConnectorIP")){
            if((!room || room == "null") && !localStorage.getItem("X_CHECKIN_PQ_DATA")){
                sessionStorage.setItem("ConnectorIP", localStorage.getItem("ConnectorIP"))
                sessionStorage.setItem("clientId", localStorage.getItem("clientId"))

                setTimeout(() => {
                    localStorage.removeItem("ConnectorIP")
                    localStorage.removeItem("clientId")
                }, 100);
            }
        }

        if(localStorage.getItem("shownWelcomButton")){
            sessionStorage.setItem("shownWelcomButton", true);
        }

        localStorage.removeItem("loginAuthToken");
        localStorage.removeItem("checkFirebaseMessageReceived")
        localStorage.removeItem('currentDuration')
        localStorage.removeItem("isDoorKeyInLayout")
        sessionStorage.removeItem("accompanyGuestDynamicFormFilledOnce");
        localStorage.removeItem("checkin_bdetails_event_sent")
        localStorage.removeItem("checkin_bnumber_event_sent")
        localStorage.removeItem("checkin_clicked_event_sent")
        localStorage.removeItem("clear_id_verification_event_sent")
        localStorage.removeItem("checkin_id_capture_event_sent")
        localStorage.removeItem("checkin_verifying_identity_event_sent")
        localStorage.removeItem("checkin_selfie_capture_event_sent")
        localStorage.removeItem("checkin_fchbooking_event_sent")
        localStorage.removeItem("checkin_ccdetails_event_sent");
        localStorage.removeItem("checkin_companion_guest_event_sent")
        localStorage.removeItem("checkin_companion_event_sent")
        localStorage.removeItem("early_checkIn_event_sent")
        localStorage.removeItem("dk_front_desk_verification_event_sent")
        localStorage.removeItem("dk_front_desk_verification_success_event_sent")
        localStorage.removeItem("dk_otp_verification_event_sent")
        localStorage.removeItem("dk_otp_verification_success_event_sent")
        localStorage.removeItem("dk_qr_verification_success_event_sent")
        localStorage.removeItem("dk_validate_getting_key_event_sent")
        localStorage.removeItem("dk_validate_key_received_event_sent")
        localStorage.removeItem("checkinSessionToken")
        localStorage.removeItem("cardVerfied")
        localStorage.removeItem("GuestCommentHcommerce")
        localStorage.removeItem('defaultThemeCssFileLoaded')
        localStorage.setItem("savedOrders", "");

        localStorage.removeItem('storeLevel1EventSent')
        localStorage.removeItem('storeLevel2EventSent')
        localStorage.removeItem('storeLevel3EventSent')
        localStorage.removeItem("storeInfoFetchEventSent")
        localStorage.removeItem('storeInfoDetailEventSent')
        localStorage.removeItem('placeOrderEventSent')
        localStorage.removeItem('placeOrderSuccessEventSent')
        localStorage.removeItem('addonEventSent')
        localStorage.removeItem("cartEventSent")
        localStorage.removeItem("additionalRequestsEventSent")
        localStorage.removeItem("mapEventSent")

        localStorage.removeItem("roomControlInterface")

        localStorage.removeItem("spaBookingClicked")
        
        localStorage.removeItem("resReservationClicked");

        sessionStorage.removeItem("openInnspireChatBot");

        sessionStorage.removeItem("setLocationOnComponentMount")
        
        registerDmqEvent();
        
        const checkinSessionToken = generateToken() 
        localStorage.setItem("checkinSessionToken", checkinSessionToken);

        const hcommerceSessionToken = generateToken("hcommerce_")
        localStorage.setItem("hcommerceSessionToken", hcommerceSessionToken);

        const resReservationSessionToken = generateToken("resReservation_")
        localStorage.setItem("resReservationSessionToken", resReservationSessionToken);

        const resReservationV2SessionToken = generateToken("resReservationV2_")
        localStorage.setItem("resReservationV2SessionToken", resReservationV2SessionToken);

        const spaBookingSessionToken = generateToken("spaBooking_")
        localStorage.setItem("spaBookingSessionToken", spaBookingSessionToken);

        const ghaSessionToken = generateToken("gha_")
        localStorage.setItem("ghaSessionToken", ghaSessionToken);
        const activityBookingSessionToken = generateToken("activityBooking_")
        localStorage.setItem("activityBookingSessionToken", activityBookingSessionToken);

        const eventsBookingSessionToken = generateToken("eventsBooking_")
        localStorage.setItem("eventsBookingSessionToken", eventsBookingSessionToken);

        const doorKeySessionToken = generateToken("doorKey_")
        localStorage.setItem("doorKeySessionToken", doorKeySessionToken);

        if(localStorage.getItem("theKnowUserInfo") && localStorage.getItem("theKnowUserInfo")!="null" ){
            const isJustRedirected= JSON.parse(localStorage.getItem("theKnowUserInfo")).isRedirected;

            // if( window.device && window.device.platform != "Android" && !isJustRedirected ){
            //     localStorage.removeItem("theKnowUserInfo");
            // }else{
                let theKnowUserInfo = JSON.parse(localStorage.getItem("theKnowUserInfo"));
                delete theKnowUserInfo["isRedirected"];

                this.props.setExternalSignIn("memberId",theKnowUserInfo.memberId);
                this.props.setExternalSignIn("accessToken",theKnowUserInfo.accessToken);
                this.props.setExternalSignIn("refreshToken",theKnowUserInfo.refreshToken);
                this.props.setExternalSignIn("jwtIdToken",theKnowUserInfo.jwtIdToken);
                this.props.setExternalSignIn("validateAccountResponse",theKnowUserInfo.validateAccountResponse);

                localStorage.setItem("theKnowUserInfo", JSON.stringify(theKnowUserInfo));
            // }

        }


        this.props.setPreloadScreen(true);

        let isLogin = room && room != "null" ? true : false
        console.log('isLogin',isLogin)
        this.props.setGuesLogin(isLogin);
                                
        //Firebase Integration
        let firebaseIntialize = localStorage.getItem('firebaseInitialized')
        if(!firebaseIntialize || firebaseIntialize == 'null'){
            this.initializeFirebase()
        }

        window.loaderTimer = setTimeout(
            () => {
                if(this.state.isServerTimeResponse && this.state.isDeviceConfigResponse && this.state.isHotelPrefLanguageResponse){
                    this.props.setPreloadScreen(false);
                    this.props.setNotification(false, "")
                } else if(navigator.onLine){
                    // this.props.setLoader(true, "Loading is taking more time than usual.  Please wait a moment while we fetch the required data.", false)
                    this.props.setNotification(true, "It is taking longer than usual.")
                    // this.setState({serviceUnavailableMessage: 'Server Timeout' })
                    // this.props.setServiceUnavailable(true)
                }
                // this.props.popupOpenClose(true, "Network Issue.");
            }, 12000
        )

        window.timeoutTimer = window.setTimeout(
            () => {
                if(this.state.isServerTimeResponse && this.state.isDeviceConfigResponse && this.state.isHotelPrefLanguageResponse){
                    this.props.setPreloadScreen(false);
                    this.props.setNotification(false, "")
                } else if(navigator.onLine){
                    // this.props.setLoader(true, "It is taking longer than usual. Please wait we are trying to get the layout", false)
                    this.setState({serviceUnavailableMessage: 'Server Timeout' })
                    this.props.setServiceUnavailable(true)
                    this.props.setNotification(false, "")
                }
                // this.props.popupOpenClose(true, "Network Issue.");
            }, 60000
        )

        // setTimeout(() => {
        //     let token = localStorage.getItem("GuestJourneySessionToken")
        //     let installedAppVersion = localStorage.getItem('installedVersion')
        //     let installedAppPackageName = localStorage.getItem('packagename')
        //     this.props.getLatestAppVersion(token,installedAppPackageName, window.device ? window.device.platform: '', installedAppVersion, this.checkForForceUpdate);
        // }, 5000)
    
        this.pauseEventListener()
        console.log('this.props.forceUpdate',this.props.forceUpdate)
        
        if(ENABLESTICKYHEADER && this.state.room && this.state.room !== "null" ){
            var topMargin = $('header').height()
            console.log('topMargin', topMargin)
            scrollUpListenerToShowHideElement('section.widgets', 1.5, (this.props.currentHomePage.path === '/notifications'), (bool) => {this.setState({showStickyHeader: bool})})
        }

        this.getAppInfo();
        this.setState({ onlyOnce: false })
        this.setBackButtonListner();
        // console.log("componentDidMount")
        let sessionToken = localStorage.getItem('GuestJourneySessionToken');
        let guestLang = localStorage.getItem('GuestPreferedLang');
        if(guestLang && guestLang !== null) {
            this.setState({isLangSet:true})
            i18next.changeLanguage(guestLang)
        }
        this.props.updateDefaultLanguage();
        //this.props.setPreloadScreen(true);
        if (sessionToken && sessionToken != "null" && sessionToken != "undefined") {
            // console.log("setPreloadScreen true")
            this.makeLayoutAPICalls(sessionToken);
        } else {
            this.sessionTokenFlow();
        }
        /*this.timeoutTimer = window.setTimeout(
            () => {
                this.props.setPreloadScreen(false);
                // this.props.popupOpenClose(true, "Network Issue.");
            }, 6000
        )*/
        this.facebookOauthInit();
        let img = localStorage.getItem("user_profile");
        this.props.facebookProfile(img);

        // Milind: Commenting the code because camera is opening directly in the background once location popup is shown.
        /*if (window.QRScanner) {
            window.QRScanner.prepare(() => {
                console.log("device is ready for scann")
            })
        }*/
        //

        const profile_photo = localStorage.getItem('profile_photo')

        if(window.device){
            // console.log('window.device.platform',window.device.platform)
            // console.log('window.device.model',window.device.model)
            // console.log('window.device.cordova',window.device.cordova)
            // console.log('window.device.uuid',window.device.uuid)
            // console.log('window.device.version',window.device.version)
            // console.log('window.device.manufacturer',window.device.manufacturer)
            // console.log('window.device.isVirtual',window.device.isVirtual)
            // console.log('window.device.serial',window.device.serial)

            // alert('window.device.platform : ' + window.device.platform 
            // + '\nwindow.device.model : ' +  window.device.model
            // + '\nwindow.device.uuid : ' + window.device.uuid
            // + '\nwindow.device.version : ' + window.device.version
            // + '\nwindow.device.manufacturer : ' + window.device.manufacturer)

            const platform = window.device.platform;
        if(profile_photo && profile_photo != 'null' && platform != 'Android'){
            copy_to_tempstorage_if_exists('profile_photo.jpg', (uri) => {localStorage.setItem('profile_photo', uri)}, (err) => {console.log('unable to read profile photo'); localStorage.removeItem('profile_photo')});
        }
        }
        this.getDeviceLanguage();
        let temp = localStorage.getItem('GuestCheckedOut')
        console.log('temp**************', temp)

        if(localStorage.getItem('GuestCheckedOut') == 'true'){
            this.props.setSuccessFailPop(true, true)
        }

        setInterval(async() => {
            if(!this.state.appInBackground){
                this.repeatedCallForLayout()
            }
        }, 600000)

        document.getElementById('app-body').classList.remove("_gmaps_cdv_");

        let redirectFromClear = new URLSearchParams(window.location.search).get("redirectFromClear");
        
        if(redirectFromClear && localStorage.getItem("checkInGuestPreInfo")){
            const ifTokenSuccess = new URLSearchParams(window.location.search).get('success');
            const checkInClearToken = new URLSearchParams(window.location.search).get('clearToken') || null;
            const error_description = new URLSearchParams(window.location.search).get('error_description') || null;

            const clearWebVerification = {
                success: ifTokenSuccess,
                checkInClearToken: checkInClearToken,
                error_description: error_description
            }

            sessionStorage.removeItem("redirectWeb");
            sessionStorage.setItem('clearWebVerification', JSON.stringify(clearWebVerification))
        } else {
            // localStorage.removeItem("checkInGuestPreInfo")
        }

        if(window.FirebasePlugin){
            window.FirebasePlugin.onMessageReceived((message) => {
                console.log("firebase message" + JSON.stringify(message));
                if (message) {

                    if(message.type && message.type.toLowerCase() == "assaabloy"){
                        console.log("received assaabloy notification: ", message.status);
                        
                        if(window.assaabloy) { // this case is for android
                            window.assaabloy.updateEndpointStatus(message.status)
                        } else if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) { // this is for iOS
                            window.cordova.plugins.AssaAbloy.updateEndpointStatus({status: message.status});
                        }
                        return;
                    }

                    
                    if (message.messageType === "notification") {
                        console.log("Notification message received from Firebase");

                        if(message.chat == "InnSpireChat"){
                            if(window.InnspireCB) {
                                this.props.setUnreadMessageCountWeb(message.unread_msg_count && !isNaN(+message.unread_msg_count) ? +message.unread_msg_count : 0)
                            }
                        }

                        if (message.tap) {
                            if(message.appPath){
                                const eventData = {
                                    params: {
                                        appPath: message.appPath,
                                        storeSku: message.storeSku,
                                        widgetType: message.widgetType,
                                        checkInAuthToken: message.checkInAuthToken,
                                        guestDetailsToken: message.guestDetailsToken,
                                        loginAuthToken: message.loginAuthToken,
                                        hotel: message.hotel
                                    }
                                }
                                this.requiredRoute(eventData);
                            } else if(message.chat == "InnSpireChat") {
                                InnSpireChatShowConversation(this.props);
                                sessionStorage.setItem("openInnspireChatBot", true);
                            } else {
                                localStorage.setItem("checkFirebaseMessageReceived", true)
                            }
                        } else {
                            if(!this.state.appInBackground) this.callWebAppPing();
                        }
                    }
                }
            }, (error) => { console.error('error in firebase notifications', error);});
        }



        setTimeout(() => {
            if(window.StatusBar) window.StatusBar.styleDefault();
            setTimeout(() => {
                if(window.StatusBar) window.StatusBar.styleDefault();
            }, 1000);
        }, 3000);

        console.log("APP2.JS mounted")
    }

    repeatedCallForLayout = () => {
        this.props.getServerTime(() => {
            let userData = localStorage.getItem("FB_user_info");
            let sessionToken = localStorage.getItem('GuestJourneySessionToken');

            this.callForLayout(userData, sessionToken, true)
        });
    }

    componentWillUnmount() {
        window.clearInterval(this.timer);
        // // Send Analytics
        // let AppExitTime = new Date
        // let duration = calculateTimeDifference(this.state.AppLaunchTime, AppExitTime, 'minute')
        // let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        // this.props.sendAnalytics(
        //     this.props.guestDetail, 
        //     "APP_EXIT", 
        //     "EXIT", 
        //     label, 
        //     duration, 
        //     this.props.guestIsLoggedIn
        // );
        //
    }

    goHome = () => {
        this.setState({renderLaunchGuideAsPerDeepLink: true})
        console.log("this.props.currentWidgetOb",this.props.currentWidgetOb)
        let room = localStorage.getItem("room");

        if(this.props.currentWidgetOb && this.props.currentWidgetOb.widgetType == "Mobile Check-in" && !this.props.guestIsLoggedIn){
            let widgetCloseTime = new Date
            let duration = calculateTimeDifference(this.props.checkinWidgetLaunchTime, widgetCloseTime, 'second')
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                null, 
                this.props.currentWidgetOb.widgetType || "Mobile Check-in",
                EXIT, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration, 
                    "pageName": this.props.checkinCurrentPageName, 
                    "widgetSessionId": localStorage.getItem("checkinSessionToken")}, 
                0, 
                false
            );
        }

        this.props.setAccompanyGuestData([]);
        this.props.currentWidget({});
        this.props.setGoHome(false);
        localStorage.removeItem('cardVerfied')
        this.props.setItemTypeList([])
        this.props.setHcommerceWidget({})
        this.props.resetHcommerce([])
        this.props.setSelectedList([]);
        this.props.setGuestRequestList([]);
        this.props.setSelectedIdType(null);
        this.props.setIdCardImage(null);
        this.props.setIdCardImageBack(null);
        this.props.setSelfieVideo(null);
        this.props.setSelectedGuestName(null);
        this.props.setCustomLocation(null);
        this.props.setLoginRequired(false, "")

        sessionStorage.removeItem("accompanyGuestDynamicFormFilledOnce");
        localStorage.removeItem("checkin_bdetails_event_sent")
        localStorage.removeItem("checkin_bnumber_event_sent")
        localStorage.removeItem("checkin_clicked_event_sent")
        localStorage.removeItem("clear_id_verification_event_sent")
        localStorage.removeItem("checkin_id_capture_event_sent")
        localStorage.removeItem("checkin_verifying_identity_event_sent")
        localStorage.removeItem("checkin_selfie_capture_event_sent")
        localStorage.removeItem("checkin_fchbooking_event_sent")
        localStorage.removeItem("checkin_ccdetails_event_sent");
        localStorage.removeItem("checkin_companion_guest_event_sent")
        localStorage.removeItem("checkin_companion_event_sent")
        localStorage.removeItem("early_checkIn_event_sent")
        localStorage.removeItem("dk_front_desk_verification_event_sent")
        localStorage.removeItem("dk_front_desk_verification_success_event_sent")
        localStorage.removeItem("dk_otp_verification_event_sent")
        localStorage.removeItem("dk_otp_verification_success_event_sent")
        localStorage.removeItem("dk_qr_verification_success_event_sent")
        localStorage.removeItem("dk_validate_getting_key_event_sent")
        localStorage.removeItem("dk_validate_key_received_event_sent")
        localStorage.removeItem("checkinSessionToken")
        localStorage.removeItem("GuestCommentHcommerce")
        localStorage.setItem("savedOrders", "");

        localStorage.removeItem('storeLevel1EventSent')
        localStorage.removeItem('storeLevel2EventSent')
        localStorage.removeItem("storeInfoFetchEventSent")
        localStorage.removeItem('storeLevel3EventSent')
        localStorage.removeItem('storeInfoDetailEventSent')
        localStorage.removeItem('placeOrderEventSent')
        localStorage.removeItem('placeOrderSuccessEventSent')
        localStorage.removeItem('addonEventSent')
        localStorage.removeItem("cartEventSent")
        localStorage.removeItem("additionalRequestsEventSent")
        localStorage.removeItem("mapEventSent")

        localStorage.removeItem("spaBookingClicked")

        localStorage.removeItem("resReservationClicked");
        
        sessionStorage.removeItem("setLocationOnComponentMount")

        const checkinSessionToken = generateToken() 
        localStorage.setItem("checkinSessionToken", checkinSessionToken);

        const hcommerceSessionToken = generateToken("hcommerce_")
        localStorage.setItem("hcommerceSessionToken", hcommerceSessionToken);

        const resReservationSessionToken = generateToken("resReservation_")
        localStorage.setItem("resReservationSessionToken", resReservationSessionToken);

        const resReservationV2SessionToken = generateToken("resReservationV2_")
        localStorage.setItem("resReservationV2SessionToken", resReservationV2SessionToken);

        const spaBookingSessionToken = generateToken("spaBooking_")
        localStorage.setItem("spaBookingSessionToken", spaBookingSessionToken);

        const ghaSessionToken = generateToken("gha_")
        localStorage.setItem("ghaSessionToken", ghaSessionToken);
        const activityBookingSessionToken = generateToken("activityBooking_")
        localStorage.setItem("activityBookingSessionToken", activityBookingSessionToken);

        const eventsBookingSessionToken = generateToken("eventsBooking_")
        localStorage.setItem("eventsBookingSessionToken", eventsBookingSessionToken);

        const doorKeySessionToken = generateToken("doorKey_")
        localStorage.setItem("doorKeySessionToken", doorKeySessionToken);

        this.props.setRedirectInfo({})
        this.setState({redirectOnLoadVar: false})


        fetchAdhoc(this.props);

        return (
            <HashRouter>
                {
                    /* TODO: Current change while merging. */
                     // this.props.currentHomePage.path === "/mystay" ?
                    //     <Redirect exact to='/mystay' /> : <Redirect exact to='/explore' />
                    (this.props.currentHomePage && notificationKeys.some(el => el === this.props.currentHomePage.uniqueKey))
                    ? <Redirect exact to='/notifications' />
                    : (this.props.currentHomePage && locationSelectorWidget.some(el => el === this.props.currentHomePage.uniqueKey)) 
                    ? <Redirect exact to='/selectHotel' />
                    : (this.props.currentHomePage && bookVirginListAtTabClickKeys.some(el => el === this.props.currentHomePage.uniqueKey)) 
                    ? <Redirect exact to='/book-virgin' />
                    : (this.props.currentHomePage && ((theKnowKeys.some(el => el === this.props.currentHomePage.uniqueKey) && this.props.externalSignIn.memberId) || (myTripsKeys.some(el => el === this.props.currentHomePage.uniqueKey) && this.props.externalSignIn.memberId)) && !sessionStorage.getItem("theKnowReservationRedirectForCheckIn")  ) 
                    ? <Redirect exact to='/theKnow' />
                    : <Redirect exact to='/' />
                    
                   /* this.props.currentHomePage.path === "/mystay" ?
                        <Redirect exact to='/mystay' /> : this.props.currentHomePage.path === '/explore' ?
                            <Redirect exact to='/explore' /> : <Redirect exact to='/notifications' /> */
                }
            </HashRouter>
        )
    }

    closeCustomScreenAfterLoader = () => {

        $("body").removeClass("overlay-cast");
        if(this.props.screenInfoAfterLoader && this.props.screenInfoAfterLoader.showOnlyAtFirstLaunch){
            localStorage.setItem("shownWelcomButton", true);
            sessionStorage.setItem("shownWelcomButton", true);
            this.setState({closeCustomAfterLoaderScreen: true });
        } else {
            sessionStorage.setItem("shownWelcomButton", true);
            this.setState({closeCustomAfterLoaderScreen: true });
        }
    }

    loadPreloader = () => {
        const selectPreloader = process.env.REACT_APP_CUSTOM_PRELOADER

        if(selectPreloader == 1){
            return (
                <CustomPreLoader1 />
            )
        } else if (selectPreloader == 2){
            return (
                <CustomPreLoader2
                    isDeviceConfigResponse={this.state.isDeviceConfigResponse}
                    isServerTimeResponse={this.state.isServerTimeResponse}
                    isHotelPrefLanguageResponse={this.state.isHotelPrefLanguageResponse}
                />
            )
        } else {
            return (
                <PreLoaderScreen />
            )
        }
    }

    loadAfterLoader = () => {

        let room = localStorage.getItem("room");
        const selectScreenAfterLoader = this.props.screenInfoAfterLoader


        const returnScreenAfterLoader = () => {
            if (selectScreenAfterLoader.screenType == "animation1") {
                return (
                    <CustomAfterLoaderScreen1 handleRedirect={(data) => {this.closeCustomScreenAfterLoader();this.requiredRoute(data)}} closeCustomScreenAfterLoader={this.closeCustomScreenAfterLoader} />
                )
            } else {
                return (
                    <CustomAfterLoaderScreen2 handleRedirect={(data) => {this.closeCustomScreenAfterLoader();this.requiredRoute(data)}} closeCustomScreenAfterLoader={this.closeCustomScreenAfterLoader} />
                )
            }
        }

        if (selectScreenAfterLoader && selectScreenAfterLoader.showAfterScreen) {

            if(room && room != "null"){
                if(selectScreenAfterLoader.showAfterLogin){
                    return returnScreenAfterLoader();
                } else {
                    return null
                }
            } else {
                return returnScreenAfterLoader();
            }

        } else {
            return null;
        }
    }

    showLaunchGuide = () => {

        const { t } = this.props

        const currentLang = i18next.language
        const currentVersionNumber = t('guide.launchGuide.versionNumber')
        const timeout = + t('guide.launchGuide.setTimeout')

        let newShownLaunchGuideData;
        let showLaunchGuideVar = true;
        let shownLaunchGuideData = localStorage.getItem("launchGuideData") ? JSON.parse(localStorage.getItem("launchGuideData")) : []

        if(t('guide.launchGuide') && (currentVersionNumber > 0)){
        if(shownLaunchGuideData != [] ){
            shownLaunchGuideData.forEach((shownData,index) => {
                if(currentLang == shownData.lng ){
                    if(currentVersionNumber <= shownData.version){
                        showLaunchGuideVar = false;
                    } else {
                        shownLaunchGuideData.splice(index,1)
                    }
                }
            });
        }
        } else {
            showLaunchGuideVar = false;
        }


        this.setState({launchGuideCheckedState: true});
        if(showLaunchGuideVar){
            setTimeout(() => {
                if(!this.state.launchGuideState){

                    const currentMetaData = {
                        lng: currentLang,
                        version: currentVersionNumber
                    }
        
                    newShownLaunchGuideData = [ ...shownLaunchGuideData, currentMetaData]
                    localStorage.setItem("launchGuideData", JSON.stringify(newShownLaunchGuideData));

                    this.setState({launchGuideState: true})
                }
            }, timeout);

            return true;
        } else {
            return false;
        }
    }

    render() {

        let room = localStorage.getItem("room");

        return (
            this.props.QRScanPage ?
                <QRScannerPage /> :
                <div >
                    {
                        console.log("preloader configs state: ", this.props.renderHomePage, this.props.preloadScreen, this.state.isDeviceConfigResponse, this.state.isServerTimeResponse, this.state.isHotelPrefLanguageResponse )
                    }
                    {
                        !this.props.renderHomePage || (this.props.preloadScreen && !(this.state.isDeviceConfigResponse && this.state.isServerTimeResponse && this.state.isHotelPrefLanguageResponse))
                        ? this.loadPreloader()
                        : (sessionStorage.getItem("shownWelcomButton") == "true" || this.state.closeCustomAfterLoaderScreen ) ? null 
                        : this.loadAfterLoader()
                    }
                    
                    {console.log('layout configs', this.state.isHotelPrefLanguageResponse, this.state.isDeviceConfigResponse, this.state.isServerTimeResponse)}
                    {
                        // isWrongLayout == 'true' && <NoConnection error={true}/>
                        //LayoutMaster == 'webapp-type1'
                    }{console.log('hcommerce_zoom_mapview', this.props.hcommerce_zoom_mapview)}

                    {this.state.launchGuideState ? <LaunchGuide closeLaunchGuide={() => this.setState({launchGuideState: false})}  /> : null}

                    {
                        this.props.showHome ?
                            this.props.GuestDevReg ?
                            
                              INROOMTAB ? <AppInfoPage /> : <GuestLoginPage />
                                :
                                <div style={{ zIndex: 0 }}>
                                    {
                                        !this.props.currentWidgetOb.widgetType &&
                                            this.state.showStickyHeader &&
                                            <StickyHeader setState={this.setState()}/>
                                    }
                                    {
                                        !this.props.currentWidgetOb.widgetType && this.props.renderHomePage &&
                                            <Header 
                                                openLaunchGuide={() => this.setState({launchGuideState: true}) }
                                                isNotficationTab={notificationKeys.some(el => el === (this.props.currentHomePage.uniqueKey && this.props.currentHomePage.uniqueKey.toLowerCase()))}
                                                header_class={this.props.currentHomePage.path === "/mystay" ? "myStayHeader"
                                                : this.props.currentHomePage.path === '/explore' ? "exploreHeader"
                                                : this.props.currentHomePage.path === '/notifications' ? "notificationsHeader" : 'header' } />
                                        
                                    }
                                    <HashRouter>
                                        <section id="app-body" className={`col ${room && room != "null" && "post-login" }`}>
                                            {
                                                /* TODO: Current change while merging. */
                                                (this.props.currentHomePage && notificationKeys.some(el => el === this.props.currentHomePage.uniqueKey))
                                                ? <Redirect exact to='/notifications' />
                                                : locationSelectorWidget.some(el => el === this.props.currentHomePage.uniqueKey)
                                                ? <Redirect exact to='/selectHotel' />
                                                : (this.props.currentHomePage && bookVirginListAtTabClickKeys.some(el => el === this.props.currentHomePage.uniqueKey)) 
                                                ? <Redirect exact to='/book-virgin' />
                                                : (this.props.currentHomePage && ((theKnowKeys.some(el => el === this.props.currentHomePage.uniqueKey) && this.props.externalSignIn.memberId) || (myTripsKeys.some(el => el === this.props.currentHomePage.uniqueKey) && this.props.externalSignIn.memberId))) 
                                                ? <Redirect exact to='/theKnow' />
                                                : <Redirect exact to='/' />
                                                 
                                              /*  this.props.currentHomePage.path === "/mystay" ?
                                                    <Redirect exact to='/mystay' /> : this.props.currentHomePage.path === '/explore' ?
                                                        <Redirect exact to='/explore' /> : <Redirect exact to='/notifications' /> */
                                            }

                                            {router()}
                                        </section>
                                    </HashRouter>
                                    {
                                         
                                        !this.props.currentWidgetOb.widgetType && (process.env.REACT_APP_NEWER_DESIGN=="true"?(!(this.props.currentHomePage && notificationKeys.some(el => el === this.props.currentHomePage.uniqueKey))):true) ?
                                            <FooterNavigation /> : null
                                    }
                                </div> :
                            <HashRouter>
                                {router()}
                            </HashRouter>
                    }
                    {
                        this.props.goHomeClick ?
                            this.goHome() : null
                    }
                    { this.state.webBackHandlerTriggered && this.webBackHandlerRedirectRoute() }
                    {/* <div>
                    {}
                </div> */}
                    {
                        this.props.showConfirmPopUP ?
                            <ConfirmaionPopUp /> : null
                    }
                    {
                        this.props.showDoorKeyPage ?
                            <HashRouter>
                                <Redirect exact to ={ DEMO ? "/doorKey/demoRoomDoorKey" : "/doorKey/roomDoorKey"}/>
                            </HashRouter> : null
                    }
                    {this.props.orderPopUp ?
                        <OrderSuccessPopUp /> : null
                    }
                    {this.props.doorLogin ?
                        <LoginPopUp /> : null

                    }
                    {
                        this.props.popUpShow ?
                            <PopUp />
                            : null
                    }
                    {
                        this.props.LaodingMass ?
                            <LaodingMass /> : ""
                    }
                    {
                        this.props.notInHotelPopup ?
                            <NIHPopup /> : ""
                    }
                    {
                        this.props.shouldShowCustomPopup ?
                        <CustomPopup />: ""
                    }
                    {
                        this.props.openSMSWidgetBool ?
                        <SendSMS /> : null
                    }
                    {
                        this.props.showAutoLoginPopup && <AutoLoginPopup />
                    }
                    {
                        this.props.queuedCheckInSuccess && <QueuedBookingSuccess />
                    }
                    {
                        this.props.currentSong && <CurrentPlayingSong />
                    }
                    {this.state.openBookmarkPopup && <BookmarkPopup closeBookMark={() => this.setState({openBookmarkPopup: false})} />}
                    {
                        this.props.errorPopUP ?
                            <DoorErrorPopup /> : null
                    }{console.log('this.props.serviceUnavailable',this.props.serviceUnavailable)}
                    {(this.props.deviceConfigFailed || this.props.serviceUnavailable )&&
                        <HashRouter>
                            <Redirect exact to = {`/noConnection?msg=${this.state.serviceUnavailableMessage}`}/>
                        </HashRouter>
                    }
                    {this.props.openProfileImage && <HashRouter>
                        <Redirect exact to = "/change_profile_photo"/>
                    </HashRouter>}
                    {
                        this.props.showNotificationBox 
                        && !(this.state.isDeviceConfigResponse && this.state.isServerTimeResponse && this.state.isHotelPrefLanguageResponse) 
                        && !this.props.serviceUnavailable && <NotifiicationBox notificationMessage={this.props.notificationMessage} />
                    }
                    {
                        this.props.showLoader && <Loader 
                                                    enableClose={true}
                                                    showClose={this.props.showLoaderClose} 
                                                    close={() => {
                                                                this.props.setLoader(false, null, false)
                                                                this.props.setLoaderClosed(true)
                                                            }} 
                                                    displayMsg={this.props.loaderMessage} />
                    }
                    {
                        this.props.showSucFailPop && <SuccessFailCheckoutPopUp showLoader={ ( status, message ) => {this.props.setLoader(status, message)}} />
                    }
                    {this.props.openRoomDoor && <HashRouter>
                        <Redirect exact to ="/doorKey/roomDoorKey"/>
                    </HashRouter>}

                    {
                        this.props.openExternalLinkInSameTab &&
                        
                        <HashRouter>
                            <Redirect exact to ='/external-url'/>
                        </HashRouter>
                    }
                    { this.props.makeUserLoginViaFindReservation &&
                                        <HashRouter>
                                            <Redirect exact to='/checkin/id' />
                                        </HashRouter>                                              
                    }
                    {
                        this.props.showFailScreen && <SuccessFailScreen close={() => this.props.setFailScreen(false, "", "", false)} showClose={this.props.showClose} statusMessage1={this.props.failScreenMessage1} statusMessage2={this.props.failScreenMessage2} />
                    }
                    {
                        this.props.showAdminLoginPage ?
                            <AdminLoginPage /> : ""
                    }
                    {
                        <DmqEventHandler callLayoutAPI={this.repeatedCallForLayout} />
                    }
                    {this.props.showLoginRequired && <LoginRequiredOverlay overlayMessage={this.props.loginRequiredMessage} goBack={() => {
                            if(this.props.showPlaceOrder){
                                this.props.setShowPlaceOrder(false);this.props.setSelectedGuestName(null);this.props.setCustomLocation(null);this.props.setLoginRequired(false, "");
                            } else {
                                this.props.setGoHome(true);
                                this.props.setLoginRequired(false, "");
                            }
                        }} />}
                    {this.props.featureNotAvailOnWeb.enablePopup && <NotAvailWebPopup />}
                    {this.props.afterLoginHotelSelectionState.showPopup && this.state.isDeviceConfigResponse &&
                        <HotelChangeConfirmPopup
                            close={() => { sessionStorage.removeItem("redirectInfo"); this.props.setHotelSelectionAfterLoginState(false) }}
                            proceed={() => handleLocationSelect(this.props, this.props.afterLoginHotelSelectionState.hotelData, true)}
                        />
                    }
                    {
                       this.props.langWidget && !this.state.isLangSet && !this.props.guestPreferedLang && <SelectLanguagePopup setShowLangPopup={() => this.setState({isLangSet:true}) }/>
                    }
                    {console.log("this.props.showDoorKeyGuide",this.props.showDoorKeyGuide)}
                    { this.state.redirectOnLoadVar && <RedirectOnLoad /> }
                    { this.props.show_itineray_details.status && <GuestItineraryDetails />}
                    { this.props.showAdhoc && <Adhoc />}
                    {
                        this.props.showDoorKeyGuide && <DoorKeyStepsGuide
                            cameraRequired={process.env.REACT_APP_ENABLE_OTP_FLOW == "true" ? (this.props.digitalKeySupportedAuthMethods.includes("QRonTV") || this.props.digitalKeySupportedAuthMethods.includes("QRshare")) : QRSCANENABLE}
                            bluetoothCheckMsg={true}
                            otpValidation = {this.props.digitalKeySupportedAuthMethods.includes("OTP")}
                            frontdeskValidation={process.env.REACT_APP_ENABLE_OTP_FLOW == "true" ? this.props.digitalKeySupportedAuthMethods.includes("FrontdeskAPI") : VERIFY_THROUGH_CMS} 
                            qrValidation={process.env.REACT_APP_ENABLE_OTP_FLOW == "true" ? (this.props.digitalKeySupportedAuthMethods.includes("QRonTV") || this.props.digitalKeySupportedAuthMethods.includes("QRshare")) : QRSCANENABLE}
                            setStepsGuide={() => {this.props.setDoorKeyGuide(false);localStorage.setItem("DoorKeyGuideShown", true); this.props.setCallKeyclick(true)}}
                        />
                    }
                    {
                        this.props.showWarningPopup.show && 
                            <ConfirmationPopup 
                                message={this.props.showWarningPopup.msg} 
                                onYesClick={() => {
                                    this.props.setGoHome(true);
                                    this.props.setWarningPopup({show: false, msg: ""});
                                    this.props.setHCommerceSavedOrders([]);
                                    this.props.setSelectedList([]);
                                }} 
                                onNoclick={() => this.props.setWarningPopup({show: false, msg: ""})} />
                    }
                </div>
        )
    }
}
   
//export default App;
const mapStateToProps = state => {
    return {
        sessionToken: state.store.sessionToken,
        showFailScreen: state.store.failScreenconfig.showFailScreen,
        failScreenMessage1: state.store.failScreenconfig.failScreenMessage1,
        failScreenMessage2: state.store.failScreenconfig.failScreenMessage2,
        showClose: state.store.failScreenconfig.showClose,
        selectedList: state.store2.selectedList,
        roomAssistancePageStatus: state.store.roomAssistance.popupStatus,
        bgImage: state.store.home.currentDuration.launcherBgImageUrl,
        scrollWid: state.store.home.currentDuration.scrollableWidgets ?
            state.store.home.currentDuration.scrollableWidgets.widgets : [],
        browsersListPopup: state.store.browserListPopup.showPopup,
        screenInfoAfterLoader: state.store.home.screenInfoAfterLoader,
        clientConfig: state.store.home.clientConfig.webAppWidgetsInfo,
        schedules: state.store.home.clientConfig.webAppWidgetsInfo ?
            state.store.home.clientConfig.webAppWidgetsInfo.schedules : {},
        durations: state.store.home.clientConfig.webAppWidgetsInfo ?
            state.store.home.clientConfig.webAppWidgetsInfo.durations : [],
        defaultLayouts: state.store.home.clientConfig.webAppWidgetsInfo ?
            state.store.home.clientConfig.webAppWidgetsInfo.defaultLayout : {},
        MasterWidget: state.store.home.clientConfig.webAppWidgetsInfo ?
            state.store.home.clientConfig.webAppWidgetsInfo.widgetsMaster : {},
        serverTime: state.store.home.serverTimeDate.time,
        serverDay: state.store.home.serverTimeDate.currentDay,
        serverTimeDatePayload: state.store.home.serverTimeDate || {},
        latestCssData: state.store.home.latestCssData,
        currentCSSVersion: state.store.home.currentCSSVersion,
        selectedHomePage: state.store2.currentHomePage,
        latestAppData: state.store.home.latestAppData,
        languagelistData: state.store.home.languagelistData,
        showChatBubble: state.store.showChatBubble,
        guestDetail: state.store.home.guestDetails,
        guestLanguages: state.store.home.guestLanguage.preferredLanguageCode,
        hotelLanguage: state.store.home.hotelLanguages,
        durationId: state.store.home.currentDuration.durationId ?
            state.store.home.currentDuration.durationId : 0,
        layoutText: state.store.home.stringConst,
        durationLang: state.store.home.durationLang,
        faceData: state.store.faceData,
        callFacebookPopup: state.store.callFacebookPopup,
        videoPlayer: state.store.movies.videoPlayer,
        notInHotelPopup: state.store.notInHotelPopup,
        shouldShowCustomPopup:state.store.shouldShowCustomPopup,
        customPopupConfigs:state.store.customPopupConfigs,
        fbLogoutPopup: state.store.logout.status,
        LaodingMass: state.store.LaodingMass,
        acSelected: state.store.acSelected,
        adminDevicePage: state.store.adminDevicePage,
        currentHomePageBeforeNotificationTab: state.store2.currentHomePageBeforeNotificationTab,
        conformationPage: state.store.deviceReg.conformationPage,
        appLauncherWidget: state.store.appLauncher.widget,
        GuestDevReg: state.store.deviceReg.guestRegPag,
        deviceName: state.store.deviceReg.deviceName,
        brandingInfo: state.store.home.currentDuration.brandingInfo.app,
        faqUrl: state.store.home.faqUrl,
        privacyPolicyUrl: state.store.home.privacyPolicyUrl,
        isMobileTV: state.store.home.isMobileTV,
        tncUrl: state.store.home.tncUrl,
        langWidget: state.store.home.langWidget,
        firstTimeOnHome: state.store.home.firstTimeOnHome,
        menuColor: state.store.home.MenuColor,
        confromPage: state.store.confromPage,
        tvConformPage: state.store.tvChannels.conformPage,
        orderDetailPage: state.store.Hcommerce.orderDetailPage,
        guestCheckedOut: state.store.guestCheckedOut,
        guestLoginPage: state.store.guestLoginPage,
        showGuestRequestSubmitPage: state.store.guestRequest.showGuestRequestSubmitPage,
        preloadScreen: state.store.preloadScreen,
        currentWidgetOb: state.store.sideNavBar.currentWidget,
        doorLogin: state.store.doorKey.doorLogin,
        showDoorKeyPage: state.store.doorKey.showDoorKeyPage,
        QRScanPage: state.store.QRScannerPage,
        layoutType: state.store.layoutType,
        clientConfig: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.ENABLE_MULTI_LANGUAGE_SELECTION : "",
        //Store 2
        showHome: state.store2.showHome,
        SelectedNavComponent: state.store.Hcommerce.SelectedNavComponent,
        currentPage: state.store.Hcommerce.currentPage,   
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        installedAppPackageName: state.store.installedAppPackageName,
        showAdminLoginPage: state.store2.showAdminLoginPage,
        showConfirmPopUP: state.store2.confirmaionPopUp.showPopUP,
        guestDeviceLang: state.store2.guestDeviceLang,
        guestPreferedLang: state.store2.guestPreferedLang,
        // showDoorKeyPage: state.store2.doorKey.showDoorKeyPage,
        orderPopUp: state.store2.orderPopUp,
        ckeckOutConfirm: state.store2.viewBill.confirmPop,
        showSucFailPop: state.store2.viewBill.showSucFailPop,
        popUpShow: state.store2.popUpShow,
        goHomeClick: state.store2.goHomeClick,
        // openCheckin: state.store2.openCheckin,
        // openViewBill: state.store2.openViewBill,
        currentHomePage: state.store2.currentHomePage,
        errorPopUP: state.store.doorKey.errorPopUP,
        openRoomDoor:state.store2.openRoomDoor,
        showLoader: state.store2.showLoader,
        loaderMessage: state.store2.loaderMessage,
        showLoaderClose: state.store2.showLoaderClose,
        showSuccessFailPopUp: state.store2.showSuccessFailPopUp,
        showSucFailPop: state.store2.viewBill.showSucFailPop,
        deviceConfigFailed : state.store2.deviceConfigFailed,
        serviceUnavailable : state.store2.serviceUnavailable,
        hvac: state.store.InncomRoomControl.hvac,
        lightScene: state.store.InncomRoomControl.lightScene,
        cameraPermissionGranted: state.store.cameraPermissionGranted,
        curtain: state.store.InncomRoomControl.curtain,
        mobileOverlayState: state.store.mobileOverlayState,
        freshChatData: state.store.freshChatData,
        selectedAC: state.store.InncomRoomControl?
        state.store.InncomRoomControl.selectedAC : [],
        hvac: state.store.InncomRoomControl.hvac,
        showPlaceOrder: state.store2.showPlaceOrder,
        currentWindow: state.store.currentWindow,
        hcommerce_zoom_mapview: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.HCOMMERCE_ZOOM_MAPVIEW : {"zoomLevel" : "20", "mapView" : "k"},
        hcommerceWidget: state.store2.hcommerceWidget,
        subItemListStoreLevel2: state.store.Hcommerce.subItemListStoreLevel2,
        checkinWidgetLaunchTime: state.store2.checkinWidgetLaunchTime,
        storeSku: state.store2.storeSku,
        checkinCurrentPageName: state.store2.checkinCurrentPageName,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        showGuestLogin: state.store.showGuestLogin,
        showNotificationBox: state.store2.showNotificationBox,
        notificationMessage: state.store2.notificationMessage,
        showDoorKeyGuide: state.store2.showDoorKeyGuide,
        showLoginRequired: state.store.showLoginRequired,
        loginRequiredMessage: state.store.loginRequiredMessage,
        hCommerceSavedOrders: state.store.Hcommerce.hCommerceSavedOrders,
        currentZoneStep: state.store.currentZoneStep,
        selectedWindows: state.store.selectedWindows,
        redirectInfo: state.store2.redirectInfo,
        renderHomePage: state.store2.renderHomePage,
        unreadMessageCount: state.store2.unreadMessageCountChat,
        zingleOnInitiated: state.store2.zingleOnInitiated,
        selectedTintLevel: state.store.selectedTintLevel,
        currentTintWindow: state.store.currentTintWindow,
        showWarningPopup: state.store.showWarningPopup,
        openSMSWidgetBool: state.store2.openSMSWidgetBool,
        showBookmarkPopup: state.store2.showBookmarkPopup,
        afterLoginHotelSelectionState: state.store2.afterLoginHotelSelectionState,
        openProfileImage: state.store2.openProfileImage,
        featureNotAvailOnWeb: state.store2.featureNotAvailOnWeb,
        showAdhoc: state.store2.showAdhoc,
        show_itineray_details: state.store2.show_itineray_details,
        footerTabList: getTabs(state.store.home.currentDuration),
        widgetList: state.store2.sideNavBar.widgetList,
        showAutoLoginPopup: state.store2.showAutoLoginPopup.isVisible,
        queuedCheckInSuccess: state.store2.queuedCheckInSuccess,
        serverTimeDate: state.store.home.serverTimeDate.date,
        digitalKeyInterface: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.digitalKeyInterface ? state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.digitalKeyInterface : false,
        restaurantReservationInterfaceCode: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.restaurantReservationConfigs ? state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.restaurantReservationConfigs.restaurantReservationInterfaceCode : "",
        mobileCheckInDisabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled) : false,
        preCheckInEnabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled) : false,
        checkInStartTime: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.checkInStartTime,
        earlyCheckInStartTime: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.earlyCheckInStartTime,
        digitalKeySupportedAuthMethods: state.store2.digitalKeySupportedAuthMethods,
        installedAndroidSDKVersion: state.store.installedAndroidSDKVersion,
        openExternalLinkInSameTab: state.store2.openExternalLinkInSameTab,
        externalSignIn: state.store2.externalSignIn,
        currentSong: state.store.music.currentSong,
        isPlayingInBackground: state.store.music.isPlayingInBackground,
        location_data: state.store2.location_data,
        makeUserLoginViaFindReservation: state.store2.makeUserLoginViaFindReservation,
        deviceConfifApiCall: state.store2.sideNavBar.deviceConfifApiCall,
        permissionWhileDoorKeyInfo: state.store2.permissionWhileDoorKeyInfo,

    }
}

const getTabs = (duration) => {
    if (duration && duration.tabDetails && duration.tabDetails.length > 0) {
        return duration.tabDetails
    } else { return false }
}

App2.propTypes = {
    bgImage: propTypes.string,
    roomAssistancePageStatus: propTypes.bool,
    serverTime: propTypes.object,
    schedules: propTypes.object,
    durations: propTypes.arrayOf(propTypes.object),
    defaultLayouts: propTypes.object,
    guestLanguages: propTypes.string,
    hotelLanguage: propTypes.object,
    durationId: propTypes.string,
    layoutText: propTypes.object
}

export default connect(
    mapStateToProps,
    {
        roomAssistanceStatusChange,
        getClientConfig,
        getServerTime,
        setCurrentHomePage,
        setCurrentTabNavItemList,
        getWetherInfo,
        guestDetails,
        guestLanguage,
        getHotelLanguages,
        updateCurrentLayout,
        updateDurationLang,
        updateDefaultLanguage,
        setFaceData,
        fetchFaceBasedJson,
        fetchActivities,
        DefaultFaceData,
        facebookProfile,
        setNavItem,
        setNavItemExplore,
        setNavItemMystay,
        fetchSissonToken,
        setLauncherWidget,
        setRegPage,
        allColors,
        firstOnHome,
        setTVtype,
        HealthService,
        checkBookingStatus,
        setPreloadScreen,
        popupOpenClose,
        currentWidget,
        setGoHome,
        setSelectedList,
        setGuestRequestList,
        setQueuedCheckInSuccess,
        setShowAutoLoginPopup,
        setOpenCheckin,
        setOpenViewBill,
        VDAStatusApi,
        getInncomRoomControlData,
        setNavItemList,
        guestJourneyNotification,
        getGuestStepsDropdownOptions,
        setDeviceConfigFailed,
        setServiceUnavailable,
        changePage,
        setShowPlaceOrder,
        setGuestDeviceLang,
        setFAQUrl,
        getGuestItinerary,
        setPrivacyPolicyUrl,
        setTnCUrl,
        addLangWidget,
        getLatestAppVersion,
        setMobileTVPage,
        setLanguageList,
        setInstalledAppVersion,
        setAppPackageName,
        setInstalledAppBuildNo,
        setAppName,
        setShowBookmarkPopup,
        setNewHeader,
        setCameraPermission,
        setDoorKeyValidationPopUp,
        setQRScannerPage,
        setDoorKeyNotificaionPage,
        setMobileOverlayState,
        setGuestPreferedLang,
        setAcSelected,
        setSelectedAC,
        getHotelListUpdatingProps,
        setLoader,
        setSuccessFailPop,
        setCurrentWindow,
        setGuesLogin,
        sendAnalytics,
        setLoaderClosed,
        setItemTypeList,
        setChatWidgetInnitialized,
        getStoreInfo,
        showAdhocAction,
        updateAdhocData,
        setHcommerceWidget,
        resetHcommerce,
        setZingleOnStatus,
        setSelectedSubItemListStoreLevel2,
        setSelectedSubItemStoreLevel2,
        setSelectedIdType,
        setIdCardImage,
        setIdCardImageBack,
        setSelfieVideo,
        getTvLiftStatus,
        setShowTVLiftWidget,
        setHotelSelectionAfterLoginState,
        setGuestLogin,
        setPreCheckInWidgetState,
        getSurvey,
        setRedirectInfo,
        setAccompanyGuestData,
        setFailScreen,
        setCheckinGuestList,
        setNotification,
        setDoorKeyGuide,
        setLoginRequired,
        setWarningPopup,
        setRenderHomePage,
        setUnreadMessageCountWeb,
        setHCommerceSavedOrders,
        setCustomLocation, setSelectedGuestName, saveGuestRequest,
        setCurrentZoneStep,
        setCurrentWindowTintPage,
        setSelectedTintLevel,
        getDigitalKeySupportedAuthMethods,
        setInstalledAndroidSDKVersion,
        setCallKeyclick,
        setOpenExternalLinkInSameTab,
        setExternalSignIn,
        getRoomControlZonesWiseData,
        setDeviceConfifApiCall,
        setPermissionWhileDoorKeyInfo,
        setShowCustomPopup
    }
)(withTranslation('translations')(App2),);